import { GraphQLClient } from 'graphql-request';
import { print } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** six-digit hexadecimal string representing red, green, blue components of a web color prefixed by hash symbol # */
  Color: string;
  /** Decimal number representing dimension of display measurement */
  DisplayMeasurementDimension: any;
  /** An URL without the schema and query */
  DomainName: any;
  /** An email address */
  Email: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
  /** A language code in IANA Language Subtag Registry */
  Locale: string;
  /** Signed blob ID generated via `createDirectUpload` mutation */
  SignedBlobID: any;
  /** Standard error key path, could be either a String or Int */
  StandardErrorPathSegment: any;
  Upload: any;
}

export interface GraphQLAbilityQueryable {
  currentAbilityCanPerform?: Maybe<Scalars['Boolean']>;
}


export interface GraphQLAbilityQueryableCurrentAbilityCanPerformArgs {
  action: Scalars['String'];
}

/** Autogenerated input type of AddContact */
export interface GraphQLAddContactInput {
  userUuid: Scalars['String'];
  contactUuid: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of AddContact */
export interface GraphQLAddContactPayload {
  __typename?: 'AddContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<GraphQLAttendee>;
  success: Scalars['Boolean'];
}

/** Autogenerated input type of AdminEventCreate */
export interface GraphQLAdminEventCreateInput {
  /** EMS access token */
  emsAccessToken: Scalars['ID'];
  /** EMS event gid */
  emsEventGid: Scalars['ID'];
  /** name of the event */
  name: GraphQLLocalizableStringInput;
  /** domain of the event */
  domain: Scalars['DomainName'];
  /** supported locales of the event */
  locales: Array<Scalars['Locale']>;
  /** enabled features of the event */
  features: Array<GraphQLEventFeature>;
  /** start time of the event */
  startAt: Scalars['ISO8601DateTime'];
  /** end time of the event */
  endAt: Scalars['ISO8601DateTime'];
  /** business matching start time of the event */
  businessMatchingStartAt: Scalars['ISO8601DateTime'];
  /** business matching end time of the event */
  businessMatchingEndAt: Scalars['ISO8601DateTime'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of AdminEventCreate */
export interface GraphQLAdminEventCreatePayload {
  __typename?: 'AdminEventCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** The `Event` object created */
  event: GraphQLEvent;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLAttendee extends GraphQLAbilityQueryable {
  __typename?: 'Attendee';
  company?: Maybe<Scalars['String']>;
  currentAbilityCanPerform?: Maybe<Scalars['Boolean']>;
  customAttendeeFields?: Maybe<Scalars['JSON']>;
  email?: Maybe<Scalars['String']>;
  emsAttendeeGid?: Maybe<Scalars['String']>;
  enrichment?: Maybe<Scalars['JSON']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rongcloudToken?: Maybe<Scalars['String']>;
  /** @deprecated same query object */
  rongcloudUser?: Maybe<GraphQLAttendee>;
  /**
   * same as uuid
   * @deprecated use `uuid` instead
   */
  rongcloudUserId?: Maybe<Scalars['String']>;
  /** can only be obtained through query `attendeeByUniqueToken` */
  tickets: GraphQLAttendeeTicketConnection;
  title?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  vexpoAccessUrl?: Maybe<Scalars['String']>;
  vexpoChatTag?: Maybe<Scalars['String']>;
  vexpoChatUserDescription?: Maybe<Scalars['String']>;
}


export interface GraphQLAttendeeCurrentAbilityCanPerformArgs {
  action: Scalars['String'];
}


export interface GraphQLAttendeeTicketsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** The connection type for Attendee. */
export interface GraphQLAttendeeConnection {
  __typename?: 'AttendeeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLAttendeeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLAttendee>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
export interface GraphQLAttendeeEdge {
  __typename?: 'AttendeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLAttendee>;
}

export interface GraphQLAttendeeTicket {
  __typename?: 'AttendeeTicket';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

/** The connection type for AttendeeTicket. */
export interface GraphQLAttendeeTicketConnection {
  __typename?: 'AttendeeTicketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLAttendeeTicketEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLAttendeeTicket>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
export interface GraphQLAttendeeTicketEdge {
  __typename?: 'AttendeeTicketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLAttendeeTicket>;
}

/** Autogenerated input type of AttendeeUpdate */
export interface GraphQLAttendeeUpdateInput {
  /** ID of the attendee */
  attendeeId: Scalars['ID'];
  /** The updated first name of the attendee */
  firstName?: Maybe<Scalars['String']>;
  /** The updated last name of the attendee */
  lastName?: Maybe<Scalars['String']>;
  /** The updated email of the attendee */
  email?: Maybe<Scalars['Email']>;
  /** The updated company of the attendee */
  company?: Maybe<Scalars['String']>;
  /** The updated title of the attendee */
  title?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of AttendeeUpdate */
export interface GraphQLAttendeeUpdatePayload {
  __typename?: 'AttendeeUpdatePayload';
  /** The updated attendee */
  attendee: GraphQLAttendee;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBooth extends GraphQLNode, GraphQLAbilityQueryable {
  __typename?: 'Booth';
  appliedDesignCodename?: Maybe<Scalars['String']>;
  appointmentBookingUrl?: Maybe<Scalars['String']>;
  boothDesign?: Maybe<GraphQLBoothDesign>;
  boothDesignCanvas?: Maybe<GraphQLBoothDesignCanvasElement>;
  boothNumber?: Maybe<Scalars['String']>;
  categories: GraphQLBoothCategoryConnection;
  cmsUrl?: Maybe<Scalars['String']>;
  currentAbilityCanPerform?: Maybe<Scalars['Boolean']>;
  description: GraphQLLocalizableString;
  designElements: GraphQLBoothDesignElementConnection;
  event: GraphQLEvent;
  exhibitionName: GraphQLLocalizableString;
  hall: GraphQLHall;
  id: Scalars['ID'];
  logo: GraphQLLocalizableImage;
  /** To indicate whether meetup function is enabled */
  meetupEnabled?: Maybe<Scalars['Boolean']>;
  meetupExhibitorManagementUrl?: Maybe<Scalars['String']>;
  name: GraphQLLocalizableString;
  previewUrl?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  reportToken?: Maybe<Scalars['String']>;
  representatives?: Maybe<GraphQLAttendeeConnection>;
  rootContentElement: GraphQLBoothRootContentElement;
  rowOrder?: Maybe<Scalars['String']>;
  tier: GraphQLBoothTier;
  website?: Maybe<Scalars['String']>;
}


export interface GraphQLBoothCategoriesArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLBoothCurrentAbilityCanPerformArgs {
  action: Scalars['String'];
}


export interface GraphQLBoothDesignElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLBoothRepresentativesArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Boolean']>;
}

export interface GraphQLBoothCategory extends GraphQLNode, GraphQLBoothTaxonomy {
  __typename?: 'BoothCategory';
  /** ID of the object. */
  id: Scalars['ID'];
  name: GraphQLLocalizableString;
  parentSupercategory?: Maybe<GraphQLBoothSupercategory>;
  /** @deprecated Use `parentSupercategory` instead */
  supercategory?: Maybe<GraphQLBoothSupercategory>;
}

/** The connection type for BoothCategory. */
export interface GraphQLBoothCategoryConnection {
  __typename?: 'BoothCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBoothCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** Autogenerated input type of BoothCategoryCreate */
export interface GraphQLBoothCategoryCreateInput {
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of parent `BoothSupercategory` */
  parentSupercategoryId?: Maybe<Scalars['ID']>;
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** Name of `BoothCategory` */
  name: GraphQLLocalizableStringInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothCategoryCreate */
export interface GraphQLBoothCategoryCreatePayload {
  __typename?: 'BoothCategoryCreatePayload';
  /** The `BoothCategory` object created */
  boothCategory: GraphQLBoothCategory;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** An edge in a connection. */
export interface GraphQLBoothCategoryEdge {
  __typename?: 'BoothCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBoothCategory>;
}

/** Autogenerated input type of BoothCategoryUpdate */
export interface GraphQLBoothCategoryUpdateInput {
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of `BoothCategory` */
  categoryId: Scalars['ID'];
  /** ID of parent `BoothSupercategory` */
  parentSupercategoryId?: Maybe<Scalars['ID']>;
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** Name of `BoothCategory` */
  name?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothCategoryUpdate */
export interface GraphQLBoothCategoryUpdatePayload {
  __typename?: 'BoothCategoryUpdatePayload';
  /** The `BoothCategory` object updated */
  boothCategory: GraphQLBoothCategory;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** The connection type for Booth. */
export interface GraphQLBoothConnection {
  __typename?: 'BoothConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBooth>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

export interface GraphQLBoothContentElement {
  booth: GraphQLBooth;
  childElements: GraphQLBoothContentElementConnection;
  event: GraphQLEvent;
  id: Scalars['ID'];
  masterElement?: Maybe<GraphQLBoothMasterElement>;
  parentElement?: Maybe<GraphQLBoothContentElement>;
  rawElement: GraphQLBoothContentElement;
}


export interface GraphQLBoothContentElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** The connection type for BoothContentElement. */
export interface GraphQLBoothContentElementConnection {
  __typename?: 'BoothContentElementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothContentElementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBoothContentElement>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** Autogenerated input type of BoothContentElementDelete */
export interface GraphQLBoothContentElementDeleteInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothContentElementDelete */
export interface GraphQLBoothContentElementDeletePayload {
  __typename?: 'BoothContentElementDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothContentElement` object deleted */
  element: GraphQLBoothContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** An edge in a connection. */
export interface GraphQLBoothContentElementEdge {
  __typename?: 'BoothContentElementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBoothContentElement>;
}

/** Autogenerated input type of BoothCreate */
export interface GraphQLBoothCreateInput {
  /** ID of the booth */
  eventId: Scalars['ID'];
  /** ID of the hall */
  hallId: Scalars['ID'];
  /** ID of the booth tier */
  boothTierId: Scalars['ID'];
  /** ID of the booth design */
  designId?: Maybe<Scalars['ID']>;
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** name of the booth design */
  appliedDesignCodename?: Maybe<Scalars['String']>;
  /** Publish status of the booth */
  published?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothCreate */
export interface GraphQLBoothCreatePayload {
  __typename?: 'BoothCreatePayload';
  /** The `Booth` object created */
  booth: GraphQLBooth;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothDesign extends GraphQLNode {
  __typename?: 'BoothDesign';
  canvas?: Maybe<GraphQLBoothDesignCanvasMasterElement>;
  event?: Maybe<GraphQLEvent>;
  id: Scalars['ID'];
  name: GraphQLLocalizableString;
}

/** Action type of booth design button */
export enum GraphQLBoothDesignButtonActionType {
  /** Chat */
  Chat = 'CHAT',
  /** Meetup */
  Meetup = 'MEETUP',
  /** External link */
  ExternalLink = 'EXTERNAL_LINK',
  /** Localizable External link */
  LocalizableExternalLink = 'LOCALIZABLE_EXTERNAL_LINK',
  /** Contact Us */
  ContactUs = 'CONTACT_US',
  /** File Tab */
  FileTab = 'FILE_TAB',
  /** Live Stream */
  LiveStream = 'LIVE_STREAM',
  /** Video Call */
  VideoCall = 'VIDEO_CALL'
}

export interface GraphQLBoothDesignCanvasElement extends GraphQLNode, GraphQLBoothV2DesignElement {
  __typename?: 'BoothDesignCanvasElement';
  aspectRatio?: Maybe<GraphQLDisplayMeasurement>;
  booth: GraphQLBooth;
  height?: Maybe<GraphQLDisplayMeasurement>;
  /** ID of the object. */
  id: Scalars['ID'];
  layers: GraphQLBoothV2DesignElementConnection;
  masterElement?: Maybe<GraphQLBoothDesignMasterElement>;
  maxWidth?: Maybe<GraphQLDisplayMeasurement>;
  positionX?: Maybe<GraphQLDisplayMeasurement>;
  positionY?: Maybe<GraphQLDisplayMeasurement>;
  /** Preview of BoothDesignCanvasElement in PNG image file format */
  previewImage?: Maybe<GraphQLImage>;
  rawElement?: Maybe<GraphQLBoothV2DesignElement>;
  width?: Maybe<GraphQLDisplayMeasurement>;
}


export interface GraphQLBoothDesignCanvasElementLayersArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

export interface GraphQLBoothDesignCanvasMasterElement extends GraphQLBoothDesignMasterElement {
  __typename?: 'BoothDesignCanvasMasterElement';
  aspectRatio: GraphQLDisplayMeasurement;
  event: GraphQLEvent;
  height: GraphQLDisplayMeasurement;
  id: Scalars['ID'];
  layers: GraphQLBoothDesignMasterElementConnection;
  maxWidth: GraphQLDisplayMeasurement;
  parentElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX: GraphQLDisplayMeasurement;
  positionY: GraphQLDisplayMeasurement;
  width: GraphQLDisplayMeasurement;
}


export interface GraphQLBoothDesignCanvasMasterElementLayersArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothDesignCanvasMasterElementUpdate */
export interface GraphQLBoothDesignCanvasMasterElementUpdateInput {
  /** ID of the booth design */
  boothDesignId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** Height of element */
  height?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Width of element */
  width?: Maybe<GraphQLDisplayMeasurementInput>;
  /** X-position of element */
  positionX?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Y-position of element */
  positionY?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Z-order of element */
  zOrder?: Maybe<Scalars['Int']>;
  /** Updated parent element ID */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Aspect ratio of element */
  aspectRatio?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Max width of element */
  maxWidth?: Maybe<GraphQLDisplayMeasurementInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignCanvasMasterElementUpdate */
export interface GraphQLBoothDesignCanvasMasterElementUpdatePayload {
  __typename?: 'BoothDesignCanvasMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignCanvasMasterElement` object updated */
  element: GraphQLBoothDesignCanvasMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothDesignColorFillElement extends GraphQLNode, GraphQLBoothV2DesignElement, GraphQLBoothDesignCustomizableElement {
  __typename?: 'BoothDesignColorFillElement';
  booth: GraphQLBooth;
  fillColor?: Maybe<Scalars['Color']>;
  height?: Maybe<GraphQLDisplayMeasurement>;
  /** ID of the object. */
  id: Scalars['ID'];
  keyName?: Maybe<Scalars['String']>;
  maskImage: GraphQLLocalizableImage;
  masterElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX?: Maybe<GraphQLDisplayMeasurement>;
  positionY?: Maybe<GraphQLDisplayMeasurement>;
  rawElement?: Maybe<GraphQLBoothV2DesignElement>;
  width?: Maybe<GraphQLDisplayMeasurement>;
}

/** Autogenerated input type of BoothDesignColorFillElementUpdate */
export interface GraphQLBoothDesignColorFillElementUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  fillColor?: Maybe<Scalars['Color']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignColorFillElementUpdate */
export interface GraphQLBoothDesignColorFillElementUpdatePayload {
  __typename?: 'BoothDesignColorFillElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignColorFillElement` object created */
  element: GraphQLBoothDesignColorFillElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothDesignColorFillMasterElement extends GraphQLBoothDesignMasterElement, GraphQLBoothDesignCustomizableMasterElement {
  __typename?: 'BoothDesignColorFillMasterElement';
  event: GraphQLEvent;
  fillColor?: Maybe<Scalars['Color']>;
  height: GraphQLDisplayMeasurement;
  id: Scalars['ID'];
  keyName?: Maybe<Scalars['String']>;
  maskImage: GraphQLLocalizableImage;
  masterControlledFillColor: Scalars['Boolean'];
  parentElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX: GraphQLDisplayMeasurement;
  positionY: GraphQLDisplayMeasurement;
  width: GraphQLDisplayMeasurement;
}

/** Autogenerated input type of BoothDesignColorFillMasterElementCreate */
export interface GraphQLBoothDesignColorFillMasterElementCreateInput {
  /** ID of the booth design */
  boothDesignId: Scalars['ID'];
  /** Height of element */
  height: GraphQLDisplayMeasurementInput;
  /** Width of element */
  width: GraphQLDisplayMeasurementInput;
  /** X-position of element */
  positionX: GraphQLDisplayMeasurementInput;
  /** Y-position of element */
  positionY: GraphQLDisplayMeasurementInput;
  /** Z-order of element */
  zOrder?: Maybe<Scalars['Int']>;
  /** Updated parent element ID */
  parentElementId?: Maybe<Scalars['ID']>;
  fillColor?: Maybe<Scalars['Color']>;
  /** Mask image */
  maskImage?: Maybe<GraphQLLocalizableFileInput>;
  /** To indicate whether the fill color will be mirrored by its child elements */
  masterControlledFillColor?: Maybe<Scalars['Boolean']>;
  /** Key name of element */
  keyName: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignColorFillMasterElementCreate */
export interface GraphQLBoothDesignColorFillMasterElementCreatePayload {
  __typename?: 'BoothDesignColorFillMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignColorFillMasterElement` object created */
  element: GraphQLBoothDesignColorFillMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothDesignColorFillMasterElementUpdate */
export interface GraphQLBoothDesignColorFillMasterElementUpdateInput {
  /** ID of the booth design */
  boothDesignId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** Height of element */
  height?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Width of element */
  width?: Maybe<GraphQLDisplayMeasurementInput>;
  /** X-position of element */
  positionX?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Y-position of element */
  positionY?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Z-order of element */
  zOrder?: Maybe<Scalars['Int']>;
  /** Updated parent element ID */
  parentElementId?: Maybe<Scalars['ID']>;
  fillColor?: Maybe<Scalars['Color']>;
  /** Mask image */
  maskImage?: Maybe<GraphQLLocalizableFileInput>;
  /** To indicate whether the fill color will be mirrored by its child elements */
  masterControlledFillColor?: Maybe<Scalars['Boolean']>;
  /** Updated key name */
  keyName?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignColorFillMasterElementUpdate */
export interface GraphQLBoothDesignColorFillMasterElementUpdatePayload {
  __typename?: 'BoothDesignColorFillMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignColorFillMasterElement` object updated */
  element: GraphQLBoothDesignColorFillMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** The connection type for BoothDesign. */
export interface GraphQLBoothDesignConnection {
  __typename?: 'BoothDesignConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothDesignEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBoothDesign>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

export interface GraphQLBoothDesignContentAreaElement extends GraphQLNode, GraphQLBoothV2DesignElement, GraphQLBoothDesignCustomizableElement {
  __typename?: 'BoothDesignContentAreaElement';
  acceptedContentTypes: Array<GraphQLBoothDesignContentType>;
  booth: GraphQLBooth;
  contentImage: GraphQLLocalizableImage;
  contentPdf: GraphQLLocalizableFile;
  contentRichtextHtml: GraphQLLocalizableString;
  contentRichtextRaw: GraphQLLocalizableString;
  contentType?: Maybe<GraphQLBoothDesignContentType>;
  contentVideo: GraphQLLocalizableVideo;
  height?: Maybe<GraphQLDisplayMeasurement>;
  /** ID of the object. */
  id: Scalars['ID'];
  keyName?: Maybe<Scalars['String']>;
  masterElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX?: Maybe<GraphQLDisplayMeasurement>;
  positionY?: Maybe<GraphQLDisplayMeasurement>;
  rawElement?: Maybe<GraphQLBoothV2DesignElement>;
  thumbnailImage: GraphQLLocalizableImage;
  width?: Maybe<GraphQLDisplayMeasurement>;
}

/** Autogenerated input type of BoothDesignContentAreaElementUpdate */
export interface GraphQLBoothDesignContentAreaElementUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** List of accepted content types */
  contentType?: Maybe<GraphQLBoothDesignContentType>;
  /** Richtext raw content value when contentType is RICHTEXT */
  contentRichtextRaw?: Maybe<GraphQLLocalizableStringInput>;
  /** Richtext html content value when contentType is RICHTEXT */
  contentRichtextHtml?: Maybe<GraphQLLocalizableStringInput>;
  /** Content image value when contentType is IMAGE */
  contentImage?: Maybe<GraphQLLocalizableFileInput>;
  /** Content video value when contentType is VIDEO */
  contentVideo?: Maybe<GraphQLLocalizableFileInput>;
  /** Content pdf value when contentType is PDF */
  contentPdf?: Maybe<GraphQLLocalizableFileInput>;
  /** Thumbnail image value */
  thumbnailImage?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignContentAreaElementUpdate */
export interface GraphQLBoothDesignContentAreaElementUpdatePayload {
  __typename?: 'BoothDesignContentAreaElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignContentAreaElement` object created */
  element: GraphQLBoothDesignContentAreaElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothDesignContentAreaMasterElement extends GraphQLBoothDesignMasterElement, GraphQLBoothDesignCustomizableMasterElement {
  __typename?: 'BoothDesignContentAreaMasterElement';
  acceptedContentTypes: Array<GraphQLBoothDesignContentType>;
  event: GraphQLEvent;
  height: GraphQLDisplayMeasurement;
  id: Scalars['ID'];
  keyName?: Maybe<Scalars['String']>;
  parentElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX: GraphQLDisplayMeasurement;
  positionY: GraphQLDisplayMeasurement;
  width: GraphQLDisplayMeasurement;
}

/** Autogenerated input type of BoothDesignContentAreaMasterElementCreate */
export interface GraphQLBoothDesignContentAreaMasterElementCreateInput {
  /** ID of the booth design */
  boothDesignId: Scalars['ID'];
  /** Height of element */
  height: GraphQLDisplayMeasurementInput;
  /** Width of element */
  width: GraphQLDisplayMeasurementInput;
  /** X-position of element */
  positionX: GraphQLDisplayMeasurementInput;
  /** Y-position of element */
  positionY: GraphQLDisplayMeasurementInput;
  /** Z-order of element */
  zOrder?: Maybe<Scalars['Int']>;
  /** Updated parent element ID */
  parentElementId?: Maybe<Scalars['ID']>;
  /** List of accepted content types */
  acceptedContentTypes?: Maybe<Array<GraphQLBoothDesignContentType>>;
  /** Key name of element */
  keyName: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignContentAreaMasterElementCreate */
export interface GraphQLBoothDesignContentAreaMasterElementCreatePayload {
  __typename?: 'BoothDesignContentAreaMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignContentAreaMasterElement` object created */
  element: GraphQLBoothDesignContentAreaMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothDesignContentAreaMasterElementUpdate */
export interface GraphQLBoothDesignContentAreaMasterElementUpdateInput {
  /** ID of the booth design */
  boothDesignId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** Height of element */
  height?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Width of element */
  width?: Maybe<GraphQLDisplayMeasurementInput>;
  /** X-position of element */
  positionX?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Y-position of element */
  positionY?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Z-order of element */
  zOrder?: Maybe<Scalars['Int']>;
  /** Updated parent element ID */
  parentElementId?: Maybe<Scalars['ID']>;
  /** List of accepted content types */
  acceptedContentTypes?: Maybe<Array<GraphQLBoothDesignContentType>>;
  /** Updated key name */
  keyName?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignContentAreaMasterElementUpdate */
export interface GraphQLBoothDesignContentAreaMasterElementUpdatePayload {
  __typename?: 'BoothDesignContentAreaMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignContentAreaMasterElement` object updated */
  element: GraphQLBoothDesignContentAreaMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Available content types for booth design */
export enum GraphQLBoothDesignContentType {
  /** Image */
  Image = 'IMAGE',
  /** Richtext */
  Richtext = 'RICHTEXT',
  /** Video */
  Video = 'VIDEO',
  /** PDF */
  Pdf = 'PDF'
}

/** Autogenerated input type of BoothDesignCreate */
export interface GraphQLBoothDesignCreateInput {
  /** ID of the booth */
  eventId: Scalars['ID'];
  /** name of the booth design */
  name: GraphQLLocalizableStringInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignCreate */
export interface GraphQLBoothDesignCreatePayload {
  __typename?: 'BoothDesignCreatePayload';
  /** The `BoothDesign` object created */
  boothDesign: GraphQLBoothDesign;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothDesignCustomizableElement {
  keyName?: Maybe<Scalars['String']>;
}

export interface GraphQLBoothDesignCustomizableMasterElement {
  keyName?: Maybe<Scalars['String']>;
}

/** Autogenerated input type of BoothDesignDelete */
export interface GraphQLBoothDesignDeleteInput {
  /** ID of the booth */
  eventId: Scalars['ID'];
  /** ID of the `BoothDesign` object to update */
  boothDesignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignDelete */
export interface GraphQLBoothDesignDeletePayload {
  __typename?: 'BoothDesignDeletePayload';
  /** The `BoothDesign` object deleted */
  boothDesign: GraphQLBoothDesign;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** An edge in a connection. */
export interface GraphQLBoothDesignEdge {
  __typename?: 'BoothDesignEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBoothDesign>;
}

export interface GraphQLBoothDesignElement extends GraphQLNode {
  __typename?: 'BoothDesignElement';
  actionUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['Color']>;
  contentRichtextHtml: GraphQLLocalizableString;
  contentRichtextRaw: GraphQLLocalizableString;
  id: Scalars['ID'];
  image: GraphQLLocalizableImage;
  kind?: Maybe<GraphQLBoothDesignElementKind>;
  name: Scalars['String'];
  pdf: GraphQLLocalizableFile;
  thumbnailImage: GraphQLLocalizableImage;
  validKinds: Array<GraphQLBoothDesignElementKind>;
  video: GraphQLLocalizableVideo;
}

/** The connection type for BoothDesignElement. */
export interface GraphQLBoothDesignElementConnection {
  __typename?: 'BoothDesignElementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothDesignElementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBoothDesignElement>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
export interface GraphQLBoothDesignElementEdge {
  __typename?: 'BoothDesignElementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBoothDesignElement>;
}

/** Kind of BoothDesignElement */
export enum GraphQLBoothDesignElementKind {
  /** Color */
  Color = 'COLOR',
  /** Image */
  Image = 'IMAGE',
  /** Richtext */
  Richtext = 'RICHTEXT',
  /** Video */
  Video = 'VIDEO',
  /** PDF */
  Pdf = 'PDF'
}

/** Autogenerated input type of BoothDesignElementUpdate */
export interface GraphQLBoothDesignElementUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** name of the design element to update */
  name: Scalars['String'];
  /** Updated kind of the booth design element */
  kind?: Maybe<GraphQLBoothDesignElementKind>;
  /** Updated color value */
  color?: Maybe<Scalars['Color']>;
  /** Updated video file value */
  video?: Maybe<GraphQLLocalizableFileInput>;
  /** Updated image file value */
  image?: Maybe<GraphQLLocalizableFileInput>;
  /** Updated pdf file value */
  pdf?: Maybe<GraphQLLocalizableFileInput>;
  /** Updated thumbnail image file value */
  thumbnailImage?: Maybe<GraphQLLocalizableFileInput>;
  /** Updated raw richtext content value */
  contentRichtextRaw?: Maybe<GraphQLLocalizableStringInput>;
  /** Updated HTML richtext content value */
  contentRichtextHtml?: Maybe<GraphQLLocalizableStringInput>;
  /** Action URL */
  actionUrl?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignElementUpdate */
export interface GraphQLBoothDesignElementUpdatePayload {
  __typename?: 'BoothDesignElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignElement` object after update */
  designElement: GraphQLBoothDesignElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothDesignImageButtonElement extends GraphQLNode, GraphQLBoothV2DesignElement, GraphQLBoothDesignCustomizableElement {
  __typename?: 'BoothDesignImageButtonElement';
  actionExternalLinkUrl?: Maybe<Scalars['String']>;
  actionLocalizableExternalLinkUrl?: Maybe<GraphQLLocalizableString>;
  actionType?: Maybe<GraphQLBoothDesignButtonActionType>;
  booth: GraphQLBooth;
  height?: Maybe<GraphQLDisplayMeasurement>;
  hoverStateImage: GraphQLLocalizableImage;
  /** ID of the object. */
  id: Scalars['ID'];
  keyName?: Maybe<Scalars['String']>;
  masterElement?: Maybe<GraphQLBoothDesignMasterElement>;
  normalStateImage: GraphQLLocalizableImage;
  positionX?: Maybe<GraphQLDisplayMeasurement>;
  positionY?: Maybe<GraphQLDisplayMeasurement>;
  rawElement?: Maybe<GraphQLBoothV2DesignElement>;
  width?: Maybe<GraphQLDisplayMeasurement>;
}

/** Autogenerated input type of BoothDesignImageButtonElementUpdate */
export interface GraphQLBoothDesignImageButtonElementUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** Button action type */
  actionType?: Maybe<GraphQLBoothDesignButtonActionType>;
  /** Link of redirection on button click */
  actionExternalLinkUrl?: Maybe<Scalars['String']>;
  /** Localiable link of redirection on button click */
  actionLocalizableExternalLinkUrl?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignImageButtonElementUpdate */
export interface GraphQLBoothDesignImageButtonElementUpdatePayload {
  __typename?: 'BoothDesignImageButtonElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignImageButtonElement` object updated */
  element: GraphQLBoothDesignImageButtonElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothDesignImageButtonMasterElement extends GraphQLBoothDesignMasterElement, GraphQLBoothDesignCustomizableMasterElement {
  __typename?: 'BoothDesignImageButtonMasterElement';
  actionExternalLinkUrl?: Maybe<Scalars['String']>;
  actionLocalizableExternalLinkUrl?: Maybe<GraphQLLocalizableString>;
  actionType?: Maybe<GraphQLBoothDesignButtonActionType>;
  event: GraphQLEvent;
  height: GraphQLDisplayMeasurement;
  hoverStateImage: GraphQLLocalizableImage;
  id: Scalars['ID'];
  keyName?: Maybe<Scalars['String']>;
  masterControlledAction: Scalars['Boolean'];
  normalStateImage: GraphQLLocalizableImage;
  parentElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX: GraphQLDisplayMeasurement;
  positionY: GraphQLDisplayMeasurement;
  width: GraphQLDisplayMeasurement;
}

/** Autogenerated input type of BoothDesignImageButtonMasterElementCreate */
export interface GraphQLBoothDesignImageButtonMasterElementCreateInput {
  /** ID of the booth design */
  boothDesignId: Scalars['ID'];
  /** Height of element */
  height: GraphQLDisplayMeasurementInput;
  /** Width of element */
  width: GraphQLDisplayMeasurementInput;
  /** X-position of element */
  positionX: GraphQLDisplayMeasurementInput;
  /** Y-position of element */
  positionY: GraphQLDisplayMeasurementInput;
  /** Z-order of element */
  zOrder?: Maybe<Scalars['Int']>;
  /** Updated parent element ID */
  parentElementId?: Maybe<Scalars['ID']>;
  /** The image to be shown when the button is in normal state */
  normalStateImage: GraphQLLocalizableFileInput;
  /** The image to be shown when the button is in hover state */
  hoverStateImage: GraphQLLocalizableFileInput;
  /** To indicate whether the button behaviour will be mirrored by its child elements */
  masterControlledAction?: Maybe<Scalars['Boolean']>;
  /** Button action type */
  actionType: GraphQLBoothDesignButtonActionType;
  /** Link of redirection on button click */
  actionExternalLinkUrl?: Maybe<Scalars['String']>;
  /** Localiable link of redirection on button click */
  actionLocalizableExternalLinkUrl?: Maybe<GraphQLLocalizableStringInput>;
  /** Key name of element */
  keyName: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignImageButtonMasterElementCreate */
export interface GraphQLBoothDesignImageButtonMasterElementCreatePayload {
  __typename?: 'BoothDesignImageButtonMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignImageButtonMasterElement` object created */
  element: GraphQLBoothDesignImageButtonMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothDesignImageButtonMasterElementUpdate */
export interface GraphQLBoothDesignImageButtonMasterElementUpdateInput {
  /** ID of the booth design */
  boothDesignId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** Height of element */
  height?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Width of element */
  width?: Maybe<GraphQLDisplayMeasurementInput>;
  /** X-position of element */
  positionX?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Y-position of element */
  positionY?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Z-order of element */
  zOrder?: Maybe<Scalars['Int']>;
  /** Updated parent element ID */
  parentElementId?: Maybe<Scalars['ID']>;
  /** The image to be shown when the button is in normal state */
  normalStateImage: GraphQLLocalizableFileInput;
  /** The image to be shown when the button is in hover state */
  hoverStateImage: GraphQLLocalizableFileInput;
  /** To indicate whether the button behaviour will be mirrored by its child elements */
  masterControlledAction?: Maybe<Scalars['Boolean']>;
  /** Button action type */
  actionType?: Maybe<GraphQLBoothDesignButtonActionType>;
  /** Link of redirection on button click */
  actionExternalLinkUrl?: Maybe<Scalars['String']>;
  /** Localiable link of redirection on button click */
  actionLocalizableExternalLinkUrl?: Maybe<GraphQLLocalizableStringInput>;
  /** Updated key name */
  keyName?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignImageButtonMasterElementUpdate */
export interface GraphQLBoothDesignImageButtonMasterElementUpdatePayload {
  __typename?: 'BoothDesignImageButtonMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignImageButtonMasterElement` object updated */
  element: GraphQLBoothDesignImageButtonMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothDesignImageElement extends GraphQLNode, GraphQLBoothV2DesignElement {
  __typename?: 'BoothDesignImageElement';
  booth: GraphQLBooth;
  height?: Maybe<GraphQLDisplayMeasurement>;
  /** ID of the object. */
  id: Scalars['ID'];
  image: GraphQLLocalizableImage;
  masterElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX?: Maybe<GraphQLDisplayMeasurement>;
  positionY?: Maybe<GraphQLDisplayMeasurement>;
  rawElement?: Maybe<GraphQLBoothV2DesignElement>;
  width?: Maybe<GraphQLDisplayMeasurement>;
}

export interface GraphQLBoothDesignImageMasterElement extends GraphQLBoothDesignMasterElement {
  __typename?: 'BoothDesignImageMasterElement';
  event: GraphQLEvent;
  height: GraphQLDisplayMeasurement;
  id: Scalars['ID'];
  image: GraphQLLocalizableImage;
  parentElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX: GraphQLDisplayMeasurement;
  positionY: GraphQLDisplayMeasurement;
  width: GraphQLDisplayMeasurement;
}

/** Autogenerated input type of BoothDesignImageMasterElementCreate */
export interface GraphQLBoothDesignImageMasterElementCreateInput {
  /** ID of the booth design */
  boothDesignId: Scalars['ID'];
  /** Height of element */
  height: GraphQLDisplayMeasurementInput;
  /** Width of element */
  width: GraphQLDisplayMeasurementInput;
  /** X-position of element */
  positionX: GraphQLDisplayMeasurementInput;
  /** Y-position of element */
  positionY: GraphQLDisplayMeasurementInput;
  /** Z-order of element */
  zOrder?: Maybe<Scalars['Int']>;
  /** Updated parent element ID */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Element image */
  image?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignImageMasterElementCreate */
export interface GraphQLBoothDesignImageMasterElementCreatePayload {
  __typename?: 'BoothDesignImageMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignImageMasterElement` object created */
  element: GraphQLBoothDesignImageMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothDesignImageMasterElementUpdate */
export interface GraphQLBoothDesignImageMasterElementUpdateInput {
  /** ID of the booth design */
  boothDesignId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** Height of element */
  height?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Width of element */
  width?: Maybe<GraphQLDisplayMeasurementInput>;
  /** X-position of element */
  positionX?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Y-position of element */
  positionY?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Z-order of element */
  zOrder?: Maybe<Scalars['Int']>;
  /** Updated parent element ID */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Updated image */
  image?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignImageMasterElementUpdate */
export interface GraphQLBoothDesignImageMasterElementUpdatePayload {
  __typename?: 'BoothDesignImageMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignImageMasterElement` object updated */
  element: GraphQLBoothDesignImageMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothDesignMasterElement {
  event: GraphQLEvent;
  height: GraphQLDisplayMeasurement;
  id: Scalars['ID'];
  parentElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX: GraphQLDisplayMeasurement;
  positionY: GraphQLDisplayMeasurement;
  width: GraphQLDisplayMeasurement;
}

/** The connection type for BoothDesignMasterElement. */
export interface GraphQLBoothDesignMasterElementConnection {
  __typename?: 'BoothDesignMasterElementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothDesignMasterElementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBoothDesignMasterElement>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** Autogenerated input type of BoothDesignMasterElementDelete */
export interface GraphQLBoothDesignMasterElementDeleteInput {
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignMasterElementDelete */
export interface GraphQLBoothDesignMasterElementDeletePayload {
  __typename?: 'BoothDesignMasterElementDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignMasterElement` object deleted */
  element: GraphQLBoothDesignMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** An edge in a connection. */
export interface GraphQLBoothDesignMasterElementEdge {
  __typename?: 'BoothDesignMasterElementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBoothDesignMasterElement>;
}

export interface GraphQLBoothDesignNetworkingWidgetElement extends GraphQLNode, GraphQLBoothV2DesignElement {
  __typename?: 'BoothDesignNetworkingWidgetElement';
  booth: GraphQLBooth;
  height?: Maybe<GraphQLDisplayMeasurement>;
  /** ID of the object. */
  id: Scalars['ID'];
  masterElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX?: Maybe<GraphQLDisplayMeasurement>;
  positionY?: Maybe<GraphQLDisplayMeasurement>;
  rawElement?: Maybe<GraphQLBoothV2DesignElement>;
  width?: Maybe<GraphQLDisplayMeasurement>;
}

export interface GraphQLBoothDesignNetworkingWidgetMasterElement extends GraphQLBoothDesignMasterElement {
  __typename?: 'BoothDesignNetworkingWidgetMasterElement';
  event: GraphQLEvent;
  height: GraphQLDisplayMeasurement;
  id: Scalars['ID'];
  parentElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX: GraphQLDisplayMeasurement;
  positionY: GraphQLDisplayMeasurement;
  width: GraphQLDisplayMeasurement;
}

/** Autogenerated input type of BoothDesignNetworkingWidgetMasterElementCreate */
export interface GraphQLBoothDesignNetworkingWidgetMasterElementCreateInput {
  /** ID of the booth design */
  boothDesignId: Scalars['ID'];
  /** Height of element */
  height: GraphQLDisplayMeasurementInput;
  /** Width of element */
  width: GraphQLDisplayMeasurementInput;
  /** X-position of element */
  positionX: GraphQLDisplayMeasurementInput;
  /** Y-position of element */
  positionY: GraphQLDisplayMeasurementInput;
  /** Z-order of element */
  zOrder?: Maybe<Scalars['Int']>;
  /** Updated parent element ID */
  parentElementId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignNetworkingWidgetMasterElementCreate */
export interface GraphQLBoothDesignNetworkingWidgetMasterElementCreatePayload {
  __typename?: 'BoothDesignNetworkingWidgetMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignNetworkingWidgetMasterElement` object created */
  element: GraphQLBoothDesignNetworkingWidgetMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothDesignNetworkingWidgetMasterElementUpdate */
export interface GraphQLBoothDesignNetworkingWidgetMasterElementUpdateInput {
  /** ID of the booth design */
  boothDesignId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** Height of element */
  height?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Width of element */
  width?: Maybe<GraphQLDisplayMeasurementInput>;
  /** X-position of element */
  positionX?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Y-position of element */
  positionY?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Z-order of element */
  zOrder?: Maybe<Scalars['Int']>;
  /** Updated parent element ID */
  parentElementId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignNetworkingWidgetMasterElementUpdate */
export interface GraphQLBoothDesignNetworkingWidgetMasterElementUpdatePayload {
  __typename?: 'BoothDesignNetworkingWidgetMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDesignNetworkingWidgetMasterElement` object updated */
  element: GraphQLBoothDesignNetworkingWidgetMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothDesignUpdate */
export interface GraphQLBoothDesignUpdateInput {
  /** ID of the booth */
  eventId: Scalars['ID'];
  /** ID of the `BoothDesign` object to update */
  boothDesignId: Scalars['ID'];
  /** the updated name of the booth design */
  name: GraphQLLocalizableStringInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDesignUpdate */
export interface GraphQLBoothDesignUpdatePayload {
  __typename?: 'BoothDesignUpdatePayload';
  /** The `BoothDesign` object updated */
  boothDesign: GraphQLBoothDesign;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothDividerContentElement extends GraphQLNode, GraphQLBoothContentElement {
  __typename?: 'BoothDividerContentElement';
  booth: GraphQLBooth;
  childElements: GraphQLBoothContentElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  masterElement?: Maybe<GraphQLBoothMasterElement>;
  parentElement?: Maybe<GraphQLBoothContentElement>;
  rawElement: GraphQLBoothContentElement;
}


export interface GraphQLBoothDividerContentElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothDividerContentElementCreate */
export interface GraphQLBoothDividerContentElementCreateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDividerContentElementCreate */
export interface GraphQLBoothDividerContentElementCreatePayload {
  __typename?: 'BoothDividerContentElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDividerContentElement` object created */
  element: GraphQLBoothDividerContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothDividerContentElementUpdate */
export interface GraphQLBoothDividerContentElementUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDividerContentElementUpdate */
export interface GraphQLBoothDividerContentElementUpdatePayload {
  __typename?: 'BoothDividerContentElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDividerContentElement` object updated */
  element: GraphQLBoothDividerContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothDividerMasterElement extends GraphQLNode, GraphQLBoothMasterElement {
  __typename?: 'BoothDividerMasterElement';
  childElements: GraphQLBoothMasterElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  parentElement?: Maybe<GraphQLBoothMasterElement>;
}


export interface GraphQLBoothDividerMasterElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothDividerMasterElementCreate */
export interface GraphQLBoothDividerMasterElementCreateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDividerMasterElementCreate */
export interface GraphQLBoothDividerMasterElementCreatePayload {
  __typename?: 'BoothDividerMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDividerMasterElement` object created */
  element: GraphQLBoothDividerMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothDividerMasterElementUpdate */
export interface GraphQLBoothDividerMasterElementUpdateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothDividerMasterElementUpdate */
export interface GraphQLBoothDividerMasterElementUpdatePayload {
  __typename?: 'BoothDividerMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothDividerMasterElement` object updated */
  element: GraphQLBoothDividerMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** An edge in a connection. */
export interface GraphQLBoothEdge {
  __typename?: 'BoothEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBooth>;
}

export interface GraphQLBoothFileContentElement extends GraphQLNode, GraphQLBoothContentElement {
  __typename?: 'BoothFileContentElement';
  booth: GraphQLBooth;
  childElements: GraphQLBoothContentElementConnection;
  event: GraphQLEvent;
  file: GraphQLLocalizableFile;
  /** ID of the object. */
  id: Scalars['ID'];
  masterElement?: Maybe<GraphQLBoothMasterElement>;
  parentElement?: Maybe<GraphQLBoothContentElement>;
  rawElement: GraphQLBoothContentElement;
}


export interface GraphQLBoothFileContentElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothFileContentElementCreate */
export interface GraphQLBoothFileContentElementCreateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** File value */
  file?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothFileContentElementCreate */
export interface GraphQLBoothFileContentElementCreatePayload {
  __typename?: 'BoothFileContentElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothFileContentElement` object created */
  element: GraphQLBoothFileContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothFileContentElementUpdate */
export interface GraphQLBoothFileContentElementUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** File value */
  file?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothFileContentElementUpdate */
export interface GraphQLBoothFileContentElementUpdatePayload {
  __typename?: 'BoothFileContentElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothFileContentElement` object updated */
  element: GraphQLBoothFileContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothFileMasterElement extends GraphQLNode, GraphQLBoothMasterElement {
  __typename?: 'BoothFileMasterElement';
  childElements: GraphQLBoothMasterElementConnection;
  event: GraphQLEvent;
  file: GraphQLLocalizableFile;
  /** ID of the object. */
  id: Scalars['ID'];
  masterControlledFile: Scalars['Boolean'];
  parentElement?: Maybe<GraphQLBoothMasterElement>;
}


export interface GraphQLBoothFileMasterElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothFileMasterElementCreate */
export interface GraphQLBoothFileMasterElementCreateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** To indicate whether the file content will be mirrored by its content elements */
  masterControlledFile?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** File value */
  file?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothFileMasterElementCreate */
export interface GraphQLBoothFileMasterElementCreatePayload {
  __typename?: 'BoothFileMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothFileMasterElement` object created */
  element: GraphQLBoothFileMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothFileMasterElementUpdate */
export interface GraphQLBoothFileMasterElementUpdateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** To indicate whether the file content will be mirrored by its content elements */
  masterControlledFile?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** File value */
  file?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothFileMasterElementUpdate */
export interface GraphQLBoothFileMasterElementUpdatePayload {
  __typename?: 'BoothFileMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothFileMasterElement` object updated */
  element: GraphQLBoothFileMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothImageContentElement extends GraphQLNode, GraphQLBoothContentElement {
  __typename?: 'BoothImageContentElement';
  booth: GraphQLBooth;
  childElements: GraphQLBoothContentElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  image: GraphQLLocalizableImage;
  masterElement?: Maybe<GraphQLBoothMasterElement>;
  parentElement?: Maybe<GraphQLBoothContentElement>;
  rawElement: GraphQLBoothContentElement;
}


export interface GraphQLBoothImageContentElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothImageContentElementCreate */
export interface GraphQLBoothImageContentElementCreateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Image file value */
  image?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothImageContentElementCreate */
export interface GraphQLBoothImageContentElementCreatePayload {
  __typename?: 'BoothImageContentElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothImageContentElement` object created */
  element: GraphQLBoothImageContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothImageContentElementUpdate */
export interface GraphQLBoothImageContentElementUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Image file value */
  image?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothImageContentElementUpdate */
export interface GraphQLBoothImageContentElementUpdatePayload {
  __typename?: 'BoothImageContentElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothImageContentElement` object updated */
  element: GraphQLBoothImageContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothImageMasterElement extends GraphQLNode, GraphQLBoothMasterElement {
  __typename?: 'BoothImageMasterElement';
  childElements: GraphQLBoothMasterElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  image: GraphQLLocalizableImage;
  masterControlledImage: Scalars['Boolean'];
  parentElement?: Maybe<GraphQLBoothMasterElement>;
}


export interface GraphQLBoothImageMasterElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothImageMasterElementCreate */
export interface GraphQLBoothImageMasterElementCreateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** To indicate whether the image content will be mirrored by its content elements */
  masterControlledImage?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Image file value */
  image?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothImageMasterElementCreate */
export interface GraphQLBoothImageMasterElementCreatePayload {
  __typename?: 'BoothImageMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothImageMasterElement` object created */
  element: GraphQLBoothImageMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothImageMasterElementUpdate */
export interface GraphQLBoothImageMasterElementUpdateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** To indicate whether the image content will be mirrored by its content elements */
  masterControlledImage?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Image file value */
  image?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothImageMasterElementUpdate */
export interface GraphQLBoothImageMasterElementUpdatePayload {
  __typename?: 'BoothImageMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothImageMasterElement` object updated */
  element: GraphQLBoothImageMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothMasterElement {
  childElements: GraphQLBoothMasterElementConnection;
  event: GraphQLEvent;
  id: Scalars['ID'];
  parentElement?: Maybe<GraphQLBoothMasterElement>;
}


export interface GraphQLBoothMasterElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** The connection type for BoothMasterElement. */
export interface GraphQLBoothMasterElementConnection {
  __typename?: 'BoothMasterElementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothMasterElementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBoothMasterElement>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** Autogenerated input type of BoothMasterElementDelete */
export interface GraphQLBoothMasterElementDeleteInput {
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothMasterElementDelete */
export interface GraphQLBoothMasterElementDeletePayload {
  __typename?: 'BoothMasterElementDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothMasterElement` object deleted */
  element: GraphQLBoothMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** An edge in a connection. */
export interface GraphQLBoothMasterElementEdge {
  __typename?: 'BoothMasterElementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBoothMasterElement>;
}

export interface GraphQLBoothQuestionContentElement extends GraphQLNode, GraphQLBoothContentElement {
  __typename?: 'BoothQuestionContentElement';
  answer?: Maybe<GraphQLBoothContentElement>;
  booth: GraphQLBooth;
  childElements: GraphQLBoothContentElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  masterElement?: Maybe<GraphQLBoothMasterElement>;
  parentElement?: Maybe<GraphQLBoothContentElement>;
  question: GraphQLLocalizableString;
  rawElement: GraphQLBoothContentElement;
}


export interface GraphQLBoothQuestionContentElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothQuestionContentElementCreate */
export interface GraphQLBoothQuestionContentElementCreateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Question value */
  question?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothQuestionContentElementCreate */
export interface GraphQLBoothQuestionContentElementCreatePayload {
  __typename?: 'BoothQuestionContentElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothQuestionContentElement` object created */
  element: GraphQLBoothQuestionContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothQuestionContentElementUpdate */
export interface GraphQLBoothQuestionContentElementUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Question value */
  question?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothQuestionContentElementUpdate */
export interface GraphQLBoothQuestionContentElementUpdatePayload {
  __typename?: 'BoothQuestionContentElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothQuestionContentElement` object updated */
  element: GraphQLBoothQuestionContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothQuestionMasterElement extends GraphQLNode, GraphQLBoothMasterElement {
  __typename?: 'BoothQuestionMasterElement';
  answer?: Maybe<GraphQLBoothMasterElement>;
  childElements: GraphQLBoothMasterElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  masterControlledAnswer: Scalars['Boolean'];
  masterControlledQuestion: Scalars['Boolean'];
  parentElement?: Maybe<GraphQLBoothMasterElement>;
  question: GraphQLLocalizableString;
}


export interface GraphQLBoothQuestionMasterElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothQuestionMasterElementCreate */
export interface GraphQLBoothQuestionMasterElementCreateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** To indicate whether the question content will be mirrored by its content elements */
  masterControlledQuestion?: Maybe<Scalars['Boolean']>;
  /** To indicate whether the answer content will be mirrored by its content elements */
  masterControlledAnswer?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Question value */
  question?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothQuestionMasterElementCreate */
export interface GraphQLBoothQuestionMasterElementCreatePayload {
  __typename?: 'BoothQuestionMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothQuestionMasterElement` object created */
  element: GraphQLBoothQuestionMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothQuestionMasterElementUpdate */
export interface GraphQLBoothQuestionMasterElementUpdateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** To indicate whether the question content will be mirrored by its content elements */
  masterControlledQuestion?: Maybe<Scalars['Boolean']>;
  /** To indicate whether the answer content will be mirrored by its content elements */
  masterControlledAnswer?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Question value */
  question?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothQuestionMasterElementUpdate */
export interface GraphQLBoothQuestionMasterElementUpdatePayload {
  __typename?: 'BoothQuestionMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothQuestionMasterElement` object updated */
  element: GraphQLBoothQuestionMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothReorder */
export interface GraphQLBoothReorderInput {
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the booth */
  boothId: Scalars['ID'];
  rowOrderPosition: Scalars['Int'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothReorder */
export interface GraphQLBoothReorderPayload {
  __typename?: 'BoothReorderPayload';
  /** The `Booth` object after reordered */
  booth: GraphQLBooth;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothRepresentativeCreate */
export interface GraphQLBoothRepresentativeCreateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** First name of booth representative */
  firstName: Scalars['String'];
  /** Last name of booth representative */
  lastName?: Maybe<Scalars['String']>;
  /** Email of booth representative */
  email: Scalars['Email'];
  /** Company of the booth representative */
  company?: Maybe<Scalars['String']>;
  /** Title of the booth representative */
  title?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothRepresentativeCreate */
export interface GraphQLBoothRepresentativeCreatePayload {
  __typename?: 'BoothRepresentativeCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** The created representative */
  representative: GraphQLAttendee;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothRepresentativeDelete */
export interface GraphQLBoothRepresentativeDeleteInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the representative */
  representativeId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothRepresentativeDelete */
export interface GraphQLBoothRepresentativeDeletePayload {
  __typename?: 'BoothRepresentativeDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** The representative object deleted */
  representative: GraphQLAttendee;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothRepresentativeUpdate */
export interface GraphQLBoothRepresentativeUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the representative */
  representativeId: Scalars['ID'];
  /** The updated first name of the representative */
  firstName?: Maybe<Scalars['String']>;
  /** The updated last name of the representative */
  lastName?: Maybe<Scalars['String']>;
  /** The updated email of the representative */
  email?: Maybe<Scalars['Email']>;
  /** The updated company of the representative */
  company?: Maybe<Scalars['String']>;
  /** The updated title of the representative */
  title?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothRepresentativeUpdate */
export interface GraphQLBoothRepresentativeUpdatePayload {
  __typename?: 'BoothRepresentativeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** The updated representation */
  representative: GraphQLAttendee;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothRichtextContentElement extends GraphQLNode, GraphQLBoothContentElement {
  __typename?: 'BoothRichtextContentElement';
  booth: GraphQLBooth;
  childElements: GraphQLBoothContentElementConnection;
  contentRichtextHtml: GraphQLLocalizableString;
  contentRichtextRaw: GraphQLLocalizableString;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  masterElement?: Maybe<GraphQLBoothMasterElement>;
  parentElement?: Maybe<GraphQLBoothContentElement>;
  rawElement: GraphQLBoothContentElement;
}


export interface GraphQLBoothRichtextContentElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothRichtextContentElementCreate */
export interface GraphQLBoothRichtextContentElementCreateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Richtext raw content value */
  contentRichtextRaw?: Maybe<GraphQLLocalizableStringInput>;
  /** Richtext html content value */
  contentRichtextHtml?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothRichtextContentElementCreate */
export interface GraphQLBoothRichtextContentElementCreatePayload {
  __typename?: 'BoothRichtextContentElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothRichtextContentElement` object created */
  element: GraphQLBoothRichtextContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothRichtextContentElementUpdate */
export interface GraphQLBoothRichtextContentElementUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Richtext raw content value */
  contentRichtextRaw?: Maybe<GraphQLLocalizableStringInput>;
  /** Richtext html content value */
  contentRichtextHtml?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothRichtextContentElementUpdate */
export interface GraphQLBoothRichtextContentElementUpdatePayload {
  __typename?: 'BoothRichtextContentElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothRichtextContentElement` object updated */
  element: GraphQLBoothRichtextContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothRichtextMasterElement extends GraphQLNode, GraphQLBoothMasterElement {
  __typename?: 'BoothRichtextMasterElement';
  childElements: GraphQLBoothMasterElementConnection;
  contentRichtextHtml: GraphQLLocalizableString;
  contentRichtextRaw: GraphQLLocalizableString;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  masterControlledContent: Scalars['Boolean'];
  parentElement?: Maybe<GraphQLBoothMasterElement>;
}


export interface GraphQLBoothRichtextMasterElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothRichtextMasterElementCreate */
export interface GraphQLBoothRichtextMasterElementCreateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** To indicate whether the title content will be mirrored by its content elements */
  masterControlledContent?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Richtext raw content value */
  contentRichtextRaw?: Maybe<GraphQLLocalizableStringInput>;
  /** Richtext html content value */
  contentRichtextHtml?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothRichtextMasterElementCreate */
export interface GraphQLBoothRichtextMasterElementCreatePayload {
  __typename?: 'BoothRichtextMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothRichtextMasterElement` object created */
  element: GraphQLBoothRichtextMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothRichtextMasterElementUpdate */
export interface GraphQLBoothRichtextMasterElementUpdateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** To indicate whether the title content will be mirrored by its content elements */
  masterControlledContent?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Richtext raw content value */
  contentRichtextRaw?: Maybe<GraphQLLocalizableStringInput>;
  /** Richtext html content value */
  contentRichtextHtml?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothRichtextMasterElementUpdate */
export interface GraphQLBoothRichtextMasterElementUpdatePayload {
  __typename?: 'BoothRichtextMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothRichtextMasterElement` object updated */
  element: GraphQLBoothRichtextMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothRootContentElement extends GraphQLNode, GraphQLBoothContentElement {
  __typename?: 'BoothRootContentElement';
  booth: GraphQLBooth;
  childElements: GraphQLBoothContentElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  masterElement?: Maybe<GraphQLBoothMasterElement>;
  parentElement?: Maybe<GraphQLBoothContentElement>;
  rawElement: GraphQLBoothContentElement;
  tabs: GraphQLBoothTabContentElementConnection;
}


export interface GraphQLBoothRootContentElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLBoothRootContentElementTabsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

export interface GraphQLBoothRootMasterElement extends GraphQLNode, GraphQLBoothMasterElement {
  __typename?: 'BoothRootMasterElement';
  childElements: GraphQLBoothMasterElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  masterControlledTabs: Scalars['Boolean'];
  parentElement?: Maybe<GraphQLBoothMasterElement>;
  tabs: GraphQLBoothTabMasterElementConnection;
}


export interface GraphQLBoothRootMasterElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLBoothRootMasterElementTabsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

export interface GraphQLBoothSupercategory extends GraphQLNode, GraphQLBoothTaxonomy {
  __typename?: 'BoothSupercategory';
  /** ID of the object. */
  id: Scalars['ID'];
  name: GraphQLLocalizableString;
  parentSupercategory?: Maybe<GraphQLBoothSupercategory>;
  subcategories: GraphQLBoothTaxonomyConnection;
}


export interface GraphQLBoothSupercategorySubcategoriesArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothSupercategoryCreate */
export interface GraphQLBoothSupercategoryCreateInput {
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of parent `BoothSupercategory` */
  parentSupercategoryId?: Maybe<Scalars['ID']>;
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** Name of `BoothSupercategory` */
  name: GraphQLLocalizableStringInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothSupercategoryCreate */
export interface GraphQLBoothSupercategoryCreatePayload {
  __typename?: 'BoothSupercategoryCreatePayload';
  /** The `BoothSupercategory` object created */
  boothSupercategory: GraphQLBoothSupercategory;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothSupercategoryUpdate */
export interface GraphQLBoothSupercategoryUpdateInput {
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of target `BoothSupercategory` */
  supercategoryId: Scalars['ID'];
  /** ID of parent `BoothSupercategory` */
  parentSupercategoryId?: Maybe<Scalars['ID']>;
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** Name of `BoothSupercategory` */
  name?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothSupercategoryUpdate */
export interface GraphQLBoothSupercategoryUpdatePayload {
  __typename?: 'BoothSupercategoryUpdatePayload';
  /** The `BoothSupercategory` object updated */
  boothSupercategory: GraphQLBoothSupercategory;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothTabContentElement extends GraphQLNode, GraphQLBoothContentElement {
  __typename?: 'BoothTabContentElement';
  body: GraphQLBoothContentElementConnection;
  booth: GraphQLBooth;
  childElements: GraphQLBoothContentElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  masterElement?: Maybe<GraphQLBoothMasterElement>;
  parentElement?: Maybe<GraphQLBoothContentElement>;
  rawElement: GraphQLBoothContentElement;
  title: GraphQLLocalizableString;
}


export interface GraphQLBoothTabContentElementBodyArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLBoothTabContentElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** The connection type for BoothTabContentElement. */
export interface GraphQLBoothTabContentElementConnection {
  __typename?: 'BoothTabContentElementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothTabContentElementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBoothTabContentElement>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** Autogenerated input type of BoothTabContentElementCreate */
export interface GraphQLBoothTabContentElementCreateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Title content value */
  title?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothTabContentElementCreate */
export interface GraphQLBoothTabContentElementCreatePayload {
  __typename?: 'BoothTabContentElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothTabContentElement` object created */
  element: GraphQLBoothTabContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** An edge in a connection. */
export interface GraphQLBoothTabContentElementEdge {
  __typename?: 'BoothTabContentElementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBoothTabContentElement>;
}

/** Autogenerated input type of BoothTabContentElementUpdate */
export interface GraphQLBoothTabContentElementUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Title content value */
  title?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothTabContentElementUpdate */
export interface GraphQLBoothTabContentElementUpdatePayload {
  __typename?: 'BoothTabContentElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothTabContentElement` object updated */
  element: GraphQLBoothTabContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothTabMasterElement extends GraphQLNode, GraphQLBoothMasterElement {
  __typename?: 'BoothTabMasterElement';
  body: GraphQLBoothMasterElementConnection;
  childElements: GraphQLBoothMasterElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  masterControlledBody: Scalars['Boolean'];
  masterControlledTitle: Scalars['Boolean'];
  parentElement?: Maybe<GraphQLBoothMasterElement>;
  title: GraphQLLocalizableString;
}


export interface GraphQLBoothTabMasterElementBodyArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLBoothTabMasterElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** The connection type for BoothTabMasterElement. */
export interface GraphQLBoothTabMasterElementConnection {
  __typename?: 'BoothTabMasterElementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothTabMasterElementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBoothTabMasterElement>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** Autogenerated input type of BoothTabMasterElementCreate */
export interface GraphQLBoothTabMasterElementCreateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** To indicate whether the title content will be mirrored by its content elements */
  masterControlledTitle?: Maybe<Scalars['Boolean']>;
  /** To indicate whether the body content will be mirrored by its content elements */
  masterControlledBody?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Title content value */
  title?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothTabMasterElementCreate */
export interface GraphQLBoothTabMasterElementCreatePayload {
  __typename?: 'BoothTabMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothTabMasterElement` object created */
  element: GraphQLBoothTabMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** An edge in a connection. */
export interface GraphQLBoothTabMasterElementEdge {
  __typename?: 'BoothTabMasterElementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBoothTabMasterElement>;
}

/** Autogenerated input type of BoothTabMasterElementUpdate */
export interface GraphQLBoothTabMasterElementUpdateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** To indicate whether the title content will be mirrored by its content elements */
  masterControlledTitle?: Maybe<Scalars['Boolean']>;
  /** To indicate whether the body content will be mirrored by its content elements */
  masterControlledBody?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Title content value */
  title?: Maybe<GraphQLLocalizableStringInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothTabMasterElementUpdate */
export interface GraphQLBoothTabMasterElementUpdatePayload {
  __typename?: 'BoothTabMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothTabMasterElement` object updated */
  element: GraphQLBoothTabMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothTaxonomy {
  id: Scalars['ID'];
  name: GraphQLLocalizableString;
  parentSupercategory?: Maybe<GraphQLBoothSupercategory>;
}

/** The connection type for BoothTaxonomy. */
export interface GraphQLBoothTaxonomyConnection {
  __typename?: 'BoothTaxonomyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothTaxonomyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBoothTaxonomy>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** Autogenerated input type of BoothTaxonomyDelete */
export interface GraphQLBoothTaxonomyDeleteInput {
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of `BoothTaxonomy` */
  taxonomyId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothTaxonomyDelete */
export interface GraphQLBoothTaxonomyDeletePayload {
  __typename?: 'BoothTaxonomyDeletePayload';
  /** The `BoothTaxonomy` object deleted */
  boothTaxonomy: GraphQLBoothTaxonomy;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** An edge in a connection. */
export interface GraphQLBoothTaxonomyEdge {
  __typename?: 'BoothTaxonomyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBoothTaxonomy>;
}

export interface GraphQLBoothTier extends GraphQLNode {
  __typename?: 'BoothTier';
  booths: GraphQLBoothConnection;
  id: Scalars['ID'];
  name: GraphQLLocalizableString;
  nameVisible: Scalars['Boolean'];
  scale: GraphQLDisplayMeasurement;
}


export interface GraphQLBoothTierBoothsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** The connection type for BoothTier. */
export interface GraphQLBoothTierConnection {
  __typename?: 'BoothTierConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothTierEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBoothTier>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** Autogenerated input type of BoothTierCreate */
export interface GraphQLBoothTierCreateInput {
  /** ID of the event */
  eventId: Scalars['ID'];
  /** name of the booth tier */
  name: GraphQLLocalizableStringInput;
  /** (Deprecated) assign orderingPosition instead */
  rowOrderPosition?: Maybe<Scalars['Int']>;
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** The sacle value of booth thumbnail size */
  scale?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Whether the booth tier name is displayed in hall page */
  nameVisible?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothTierCreate */
export interface GraphQLBoothTierCreatePayload {
  __typename?: 'BoothTierCreatePayload';
  /** The `BoothTier` object created */
  boothTier: GraphQLBoothTier;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothTierDelete */
export interface GraphQLBoothTierDeleteInput {
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the `BoothTier` object to update */
  boothTierId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothTierDelete */
export interface GraphQLBoothTierDeletePayload {
  __typename?: 'BoothTierDeletePayload';
  /** The `BoothTier` object deleted */
  boothTier: GraphQLBoothTier;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** An edge in a connection. */
export interface GraphQLBoothTierEdge {
  __typename?: 'BoothTierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBoothTier>;
}

/** Autogenerated input type of BoothTierUpdate */
export interface GraphQLBoothTierUpdateInput {
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the `BoothTier` object to update */
  boothTierId: Scalars['ID'];
  /** The updated name of the booth tier */
  name?: Maybe<GraphQLLocalizableStringInput>;
  /** (Deprecated) assign orderingPosition instead */
  rowOrderPosition?: Maybe<Scalars['Int']>;
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** The sacle value of booth thumbnail size */
  scale?: Maybe<GraphQLDisplayMeasurementInput>;
  /** Whether the booth tier name is displayed in hall page */
  nameVisible?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothTierUpdate */
export interface GraphQLBoothTierUpdatePayload {
  __typename?: 'BoothTierUpdatePayload';
  /** The `BoothTier` object updated */
  boothTier: GraphQLBoothTier;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothUpdate */
export interface GraphQLBoothUpdateInput {
  /** ID of the booth */
  id: Scalars['ID'];
  /** Updated hall ID */
  hallId?: Maybe<Scalars['String']>;
  /** Updated booth number */
  boothNumber?: Maybe<Scalars['String']>;
  /** Updated booth tier */
  tierId?: Maybe<Scalars['ID']>;
  /** Updated booth design */
  designId?: Maybe<Scalars['ID']>;
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** Updated website URL */
  website?: Maybe<Scalars['String']>;
  /** Updated name value */
  name?: Maybe<GraphQLLocalizableStringInput>;
  /** Updated description value */
  description?: Maybe<GraphQLLocalizableStringInput>;
  /** Updated logo file value */
  logo?: Maybe<GraphQLLocalizableFileInput>;
  /** Updated exhibition name value */
  exhibitionName?: Maybe<GraphQLLocalizableStringInput>;
  /** Updated design code */
  designCodename?: Maybe<Scalars['String']>;
  /** Updated 'meetupEnabled' value */
  meetupEnabled?: Maybe<Scalars['Boolean']>;
  /** Updated ids of categories */
  categories?: Maybe<Array<Scalars['ID']>>;
  /** Update publish status of the booth */
  published?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothUpdate */
export interface GraphQLBoothUpdatePayload {
  __typename?: 'BoothUpdatePayload';
  /** The `Booth` object after update */
  booth?: Maybe<GraphQLBooth>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothV2DesignElement {
  booth: GraphQLBooth;
  height?: Maybe<GraphQLDisplayMeasurement>;
  id: Scalars['ID'];
  masterElement?: Maybe<GraphQLBoothDesignMasterElement>;
  positionX?: Maybe<GraphQLDisplayMeasurement>;
  positionY?: Maybe<GraphQLDisplayMeasurement>;
  rawElement?: Maybe<GraphQLBoothV2DesignElement>;
  width?: Maybe<GraphQLDisplayMeasurement>;
}

/** The connection type for BoothV2DesignElement. */
export interface GraphQLBoothV2DesignElementConnection {
  __typename?: 'BoothV2DesignElementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLBoothV2DesignElementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLBoothV2DesignElement>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
export interface GraphQLBoothV2DesignElementEdge {
  __typename?: 'BoothV2DesignElementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLBoothV2DesignElement>;
}

export interface GraphQLBoothVideoContentElement extends GraphQLNode, GraphQLBoothContentElement {
  __typename?: 'BoothVideoContentElement';
  booth: GraphQLBooth;
  childElements: GraphQLBoothContentElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  masterElement?: Maybe<GraphQLBoothMasterElement>;
  parentElement?: Maybe<GraphQLBoothContentElement>;
  rawElement: GraphQLBoothContentElement;
  videoFile: GraphQLLocalizableVideo;
}


export interface GraphQLBoothVideoContentElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothVideoContentElementCreate */
export interface GraphQLBoothVideoContentElementCreateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Video file value */
  videoFile?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothVideoContentElementCreate */
export interface GraphQLBoothVideoContentElementCreatePayload {
  __typename?: 'BoothVideoContentElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothVideoContentElement` object created */
  element: GraphQLBoothVideoContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothVideoContentElementUpdate */
export interface GraphQLBoothVideoContentElementUpdateInput {
  /** ID of the booth */
  boothId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Video file value */
  videoFile?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothVideoContentElementUpdate */
export interface GraphQLBoothVideoContentElementUpdatePayload {
  __typename?: 'BoothVideoContentElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothVideoContentElement` object updated */
  element: GraphQLBoothVideoContentElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLBoothVideoMasterElement extends GraphQLNode, GraphQLBoothMasterElement {
  __typename?: 'BoothVideoMasterElement';
  childElements: GraphQLBoothMasterElementConnection;
  event: GraphQLEvent;
  /** ID of the object. */
  id: Scalars['ID'];
  masterControlledVideoFile: Scalars['Boolean'];
  parentElement?: Maybe<GraphQLBoothMasterElement>;
  videoFile: GraphQLLocalizableVideo;
}


export interface GraphQLBoothVideoMasterElementChildElementsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of BoothVideoMasterElementCreate */
export interface GraphQLBoothVideoMasterElementCreateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** To indicate whether the video content will be mirrored by its content elements */
  masterControlledVideoFile?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Video file value */
  videoFile?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothVideoMasterElementCreate */
export interface GraphQLBoothVideoMasterElementCreatePayload {
  __typename?: 'BoothVideoMasterElementCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothVideoMasterElement` object created */
  element: GraphQLBoothVideoMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of BoothVideoMasterElementUpdate */
export interface GraphQLBoothVideoMasterElementUpdateInput {
  /** Assign new ordering position */
  orderingPosition?: Maybe<Scalars['Int']>;
  /** ID of the event */
  eventId: Scalars['ID'];
  /** ID of the element */
  elementId: Scalars['ID'];
  /** To indicate whether the video content will be mirrored by its content elements */
  masterControlledVideoFile?: Maybe<Scalars['Boolean']>;
  /** ID of the parent element */
  parentElementId?: Maybe<Scalars['ID']>;
  /** Video file value */
  videoFile?: Maybe<GraphQLLocalizableFileInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of BoothVideoMasterElementUpdate */
export interface GraphQLBoothVideoMasterElementUpdatePayload {
  __typename?: 'BoothVideoMasterElementUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BoothVideoMasterElement` object updated */
  element: GraphQLBoothVideoMasterElement;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}


/** Autogenerated input type of ConfirmationEmailResend */
export interface GraphQLConfirmationEmailResendInput {
  eventToken?: Maybe<Scalars['String']>;
  eventDomain?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of ConfirmationEmailResend */
export interface GraphQLConfirmationEmailResendPayload {
  __typename?: 'ConfirmationEmailResendPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Represents direct upload credentials */
export interface GraphQLDirectUpload {
  __typename?: 'DirectUpload';
  /** HTTP request headers (JSON-encoded) */
  headers: Scalars['String'];
  /** Created blob record signed ID */
  signedBlobId: Scalars['SignedBlobID'];
  /** Upload URL */
  url: Scalars['String'];
}

export interface GraphQLDisplayMeasurement {
  __typename?: 'DisplayMeasurement';
  dimension?: Maybe<Scalars['DisplayMeasurementDimension']>;
  unit: GraphQLDisplayMeasurementUnit;
}


/** Input value of DisplayMeasurement */
export interface GraphQLDisplayMeasurementInput {
  unit: GraphQLDisplayMeasurementUnit;
  dimension?: Maybe<Scalars['DisplayMeasurementDimension']>;
}

export enum GraphQLDisplayMeasurementUnit {
  /** Unit in pixel */
  Pixel = 'PIXEL',
  /** Unit in percentage */
  Percent = 'PERCENT'
}



export interface GraphQLEvent extends GraphQLNode, GraphQLAbilityQueryable {
  __typename?: 'Event';
  attendeeByUniqueToken?: Maybe<GraphQLAttendee>;
  attendeesByCustomFieldVexpoRole?: Maybe<GraphQLAttendeeConnection>;
  attendeesByKeyword?: Maybe<GraphQLAttendeeConnection>;
  attendeesByUuids?: Maybe<GraphQLAttendeeConnection>;
  booth?: Maybe<GraphQLBooth>;
  boothDesigns: GraphQLBoothDesignConnection;
  boothTaxonomies: GraphQLBoothTaxonomyConnection;
  boothTiers: GraphQLBoothTierConnection;
  booths: GraphQLBoothConnection;
  boothsByCategories: GraphQLBoothConnection;
  boothsByFilter?: Maybe<GraphQLBoothConnection>;
  cmsUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  currentAbilityCanPerform?: Maybe<Scalars['Boolean']>;
  defaultLocale: Scalars['Locale'];
  domain?: Maybe<Scalars['String']>;
  features: Array<GraphQLEventFeature>;
  halls: GraphQLHallConnection;
  id: Scalars['ID'];
  locales: Array<Scalars['Locale']>;
  meetupEventId?: Maybe<Scalars['String']>;
  name?: Maybe<GraphQLLocalizableString>;
  reportToken?: Maybe<Scalars['String']>;
  rootMasterElement: GraphQLBoothRootMasterElement;
  searchByKeyword: GraphQLSearchResultConnection;
  vexpoEventUrl?: Maybe<Scalars['String']>;
}


export interface GraphQLEventAttendeeByUniqueTokenArgs {
  uniqueToken: Scalars['String'];
}


export interface GraphQLEventAttendeesByCustomFieldVexpoRoleArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vexpoRole?: Maybe<Scalars['String']>;
}


export interface GraphQLEventAttendeesByKeywordArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
}


export interface GraphQLEventAttendeesByUuidsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  uuids: Array<Scalars['String']>;
}


export interface GraphQLEventBoothArgs {
  id: Scalars['ID'];
}


export interface GraphQLEventBoothDesignsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLEventBoothTaxonomiesArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLEventBoothTiersArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLEventBoothsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLEventBoothsByCategoriesArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIds?: Maybe<Array<Scalars['ID']>>;
}


export interface GraphQLEventBoothsByFilterArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
  categoryIds?: Maybe<Array<Scalars['ID']>>;
  published?: Maybe<Scalars['Boolean']>;
}


export interface GraphQLEventCurrentAbilityCanPerformArgs {
  action: Scalars['String'];
}


export interface GraphQLEventHallsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLEventSearchByKeywordArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
}

/** Available features for `Event` */
export enum GraphQLEventFeature {
  /** Product page */
  ProductPage = 'PRODUCT_PAGE',
  /** Exhibitor report */
  ExhibitorReport = 'EXHIBITOR_REPORT',
  /** V2 booth design elements */
  V2DesignElement = 'V2_DESIGN_ELEMENT',
  /** HKTDC Attendee API */
  HktdcAttendeeApi = 'HKTDC_ATTENDEE_API',
  /** Attendee filtering */
  AttendeeFiltering = 'ATTENDEE_FILTERING',
  /** Reverse the order of layers on mobile */
  ReversedLayerOrder = 'REVERSED_LAYER_ORDER',
  /** SKIP_EMS_ATTENDEE_LOOKUP */
  SkipEmsAttendeeLookup = 'SKIP_EMS_ATTENDEE_LOOKUP'
}

/** Autogenerated input type of EventUpdate */
export interface GraphQLEventUpdateInput {
  /** ID of the event */
  id: Scalars['ID'];
  /** Updated name of the event */
  name?: Maybe<GraphQLLocalizableStringInput>;
  /** Updated domain of the event */
  domain?: Maybe<Scalars['DomainName']>;
  /** Updated features of the event */
  features?: Maybe<Array<GraphQLEventFeature>>;
  /** Updated locales of the event */
  locales?: Maybe<Array<Scalars['Locale']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of EventUpdate */
export interface GraphQLEventUpdatePayload {
  __typename?: 'EventUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** The `Event` object after update */
  event: GraphQLEvent;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLFile extends GraphQLFileable {
  __typename?: 'File';
  contentType: Scalars['String'];
  fileUrl: Scalars['String'];
  filename: Scalars['String'];
}

export interface GraphQLFileable {
  contentType: Scalars['String'];
  fileUrl: Scalars['String'];
  filename: Scalars['String'];
}

/** Autogenerated input type of GroupChatJoinAsync */
export interface GraphQLGroupChatJoinAsyncInput {
  rongcloudUserId: Scalars['ID'];
  groupId: Scalars['String'];
  domain: Scalars['String'];
  autoJoinMessageRequired?: Maybe<Scalars['Boolean']>;
  autoJoinMessage?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of GroupChatJoinAsync */
export interface GraphQLGroupChatJoinAsyncPayload {
  __typename?: 'GroupChatJoinAsyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  job?: Maybe<GraphQLGroupChatJoinJob>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of GroupChatJoin */
export interface GraphQLGroupChatJoinInput {
  uniqueToken: Scalars['String'];
  groupId: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

export interface GraphQLGroupChatJoinJob extends GraphQLNode, GraphQLJob {
  __typename?: 'GroupChatJoinJob';
  /** ID of the object. */
  id: Scalars['ID'];
  result: GraphQLGroupChatJoinResult;
  status: GraphQLJobStatus;
}

/** Autogenerated return type of GroupChatJoin */
export interface GraphQLGroupChatJoinPayload {
  __typename?: 'GroupChatJoinPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  rongcloudGroup?: Maybe<GraphQLRongcloudGroup>;
  success: Scalars['Boolean'];
}

export interface GraphQLGroupChatJoinResult extends GraphQLJobResult {
  __typename?: 'GroupChatJoinResult';
  job: GraphQLJob;
  success: Scalars['Boolean'];
}

/** Autogenerated input type of GroupVideoCallRoomJoinResponse */
export interface GraphQLGroupVideoCallRoomJoinResponseInput {
  roomToken: Scalars['String'];
  inviterId: Scalars['String'];
  participantId: Scalars['String'];
  isApproved: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of GroupVideoCallRoomJoinResponse */
export interface GraphQLGroupVideoCallRoomJoinResponsePayload {
  __typename?: 'GroupVideoCallRoomJoinResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLHall extends GraphQLNode {
  __typename?: 'Hall';
  booths: GraphQLBoothConnection;
  boothsByCategories: GraphQLBoothConnection;
  boothsByFilter?: Maybe<GraphQLBoothConnection>;
  id: Scalars['ID'];
  name: GraphQLLocalizableString;
}


export interface GraphQLHallBoothsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}


export interface GraphQLHallBoothsByCategoriesArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIds?: Maybe<Array<Scalars['ID']>>;
}


export interface GraphQLHallBoothsByFilterArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
  categoryIds?: Maybe<Array<Scalars['ID']>>;
  published?: Maybe<Scalars['Boolean']>;
}

/** The connection type for Hall. */
export interface GraphQLHallConnection {
  __typename?: 'HallConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLHallEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLHall>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
export interface GraphQLHallEdge {
  __typename?: 'HallEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLHall>;
}

export enum GraphQLImService {
  /** RongCloud IM Service */
  Rongcloud = 'RONGCLOUD',
  /** Twilio Conversation IM Service */
  Twilio = 'TWILIO'
}


export interface GraphQLImage extends GraphQLFileable {
  __typename?: 'Image';
  contentType: Scalars['String'];
  fileUrl: Scalars['String'];
  filename: Scalars['String'];
  originalImageUrl: Scalars['String'];
}

/** File information required to prepare a direct upload */
export interface GraphQLInitiateDirectUploadInput {
  /** Original file name */
  filename: Scalars['String'];
  /** File size (bytes) */
  byteSize: Scalars['Int'];
  /** MD5 file checksum as base64 */
  checksum: Scalars['String'];
  /** File content type */
  contentType: Scalars['String'];
}

/** Autogenerated return type of InitiateDirectUpload */
export interface GraphQLInitiateDirectUploadPayload {
  __typename?: 'InitiateDirectUploadPayload';
  directUpload: GraphQLDirectUpload;
}


export interface GraphQLJob {
  id: Scalars['ID'];
  result: GraphQLJobResult;
  status: GraphQLJobStatus;
}

export interface GraphQLJobResult {
  job: GraphQLJob;
}

/** Possible value types for `status` of an `Job` */
export enum GraphQLJobStatus {
  /** Pending */
  Pending = 'PENDING',
  /** Working */
  Working = 'WORKING',
  /** Completed */
  Completed = 'COMPLETED',
  /** Failed */
  Failed = 'FAILED'
}


export interface GraphQLLocalizableFile {
  __typename?: 'LocalizableFile';
  values?: Maybe<Array<GraphQLLocalizableFileValue>>;
}


export interface GraphQLLocalizableFileValuesArgs {
  locales: Array<Scalars['Locale']>;
}

/** Container for multiple file translations values */
export interface GraphQLLocalizableFileInput {
  values?: Maybe<Array<GraphQLLocalizableFileInputValue>>;
}

/** Container for single file translation value */
export interface GraphQLLocalizableFileInputValue {
  value?: Maybe<Scalars['SignedBlobID']>;
  locale: Scalars['Locale'];
}

export interface GraphQLLocalizableFileValue {
  __typename?: 'LocalizableFileValue';
  locale: Scalars['Locale'];
  value?: Maybe<GraphQLFile>;
}

/** Localizable file-like objects */
export type GraphQLLocalizableFileable = GraphQLLocalizableFile | GraphQLLocalizableImage | GraphQLLocalizableVideo;

export interface GraphQLLocalizableImage {
  __typename?: 'LocalizableImage';
  values?: Maybe<Array<GraphQLLocalizableImageValue>>;
}


export interface GraphQLLocalizableImageValuesArgs {
  locales: Array<Scalars['Locale']>;
}

export interface GraphQLLocalizableImageValue {
  __typename?: 'LocalizableImageValue';
  locale: Scalars['Locale'];
  value?: Maybe<GraphQLImage>;
}

export interface GraphQLLocalizableString {
  __typename?: 'LocalizableString';
  values?: Maybe<Array<GraphQLLocalizableStringValue>>;
}


export interface GraphQLLocalizableStringValuesArgs {
  locales: Array<Scalars['Locale']>;
}

/** Container for multiple string translations values */
export interface GraphQLLocalizableStringInput {
  values?: Maybe<Array<GraphQLLocalizableStringInputValue>>;
}

/** Container for single string translation value */
export interface GraphQLLocalizableStringInputValue {
  value?: Maybe<Scalars['String']>;
  locale: Scalars['Locale'];
}

export interface GraphQLLocalizableStringValue {
  __typename?: 'LocalizableStringValue';
  locale: Scalars['Locale'];
  value?: Maybe<Scalars['String']>;
}

export interface GraphQLLocalizableVideo {
  __typename?: 'LocalizableVideo';
  values?: Maybe<Array<GraphQLLocalizableVideoValue>>;
}


export interface GraphQLLocalizableVideoValuesArgs {
  locales: Array<Scalars['Locale']>;
}

export interface GraphQLLocalizableVideoValue {
  __typename?: 'LocalizableVideoValue';
  locale: Scalars['Locale'];
  value?: Maybe<GraphQLVideo>;
}

export interface GraphQLMutation {
  __typename?: 'Mutation';
  addContact?: Maybe<GraphQLAddContactPayload>;
  adminEventCreate?: Maybe<GraphQLAdminEventCreatePayload>;
  attendeeUpdate?: Maybe<GraphQLAttendeeUpdatePayload>;
  boothCategoryCreate?: Maybe<GraphQLBoothCategoryCreatePayload>;
  boothCategoryUpdate?: Maybe<GraphQLBoothCategoryUpdatePayload>;
  boothContentElementDelete?: Maybe<GraphQLBoothContentElementDeletePayload>;
  boothCreate?: Maybe<GraphQLBoothCreatePayload>;
  boothDesignCanvasMasterElementUpdate?: Maybe<GraphQLBoothDesignCanvasMasterElementUpdatePayload>;
  boothDesignColorFillElementUpdate?: Maybe<GraphQLBoothDesignColorFillElementUpdatePayload>;
  boothDesignColorFillMasterElementCreate?: Maybe<GraphQLBoothDesignColorFillMasterElementCreatePayload>;
  boothDesignColorFillMasterElementUpdate?: Maybe<GraphQLBoothDesignColorFillMasterElementUpdatePayload>;
  boothDesignContentAreaElementUpdate?: Maybe<GraphQLBoothDesignContentAreaElementUpdatePayload>;
  boothDesignContentAreaMasterElementCreate?: Maybe<GraphQLBoothDesignContentAreaMasterElementCreatePayload>;
  boothDesignContentAreaMasterElementUpdate?: Maybe<GraphQLBoothDesignContentAreaMasterElementUpdatePayload>;
  boothDesignCreate?: Maybe<GraphQLBoothDesignCreatePayload>;
  boothDesignDelete?: Maybe<GraphQLBoothDesignDeletePayload>;
  boothDesignElementUpdate?: Maybe<GraphQLBoothDesignElementUpdatePayload>;
  boothDesignImageButtonElementUpdate?: Maybe<GraphQLBoothDesignImageButtonElementUpdatePayload>;
  boothDesignImageButtonMasterElementCreate?: Maybe<GraphQLBoothDesignImageButtonMasterElementCreatePayload>;
  boothDesignImageButtonMasterElementUpdate?: Maybe<GraphQLBoothDesignImageButtonMasterElementUpdatePayload>;
  boothDesignImageMasterElementCreate?: Maybe<GraphQLBoothDesignImageMasterElementCreatePayload>;
  boothDesignImageMasterElementUpdate?: Maybe<GraphQLBoothDesignImageMasterElementUpdatePayload>;
  boothDesignMasterElementDelete?: Maybe<GraphQLBoothDesignMasterElementDeletePayload>;
  boothDesignNetworkingWidgetMasterElementCreate?: Maybe<GraphQLBoothDesignNetworkingWidgetMasterElementCreatePayload>;
  boothDesignNetworkingWidgetMasterElementUpdate?: Maybe<GraphQLBoothDesignNetworkingWidgetMasterElementUpdatePayload>;
  boothDesignUpdate?: Maybe<GraphQLBoothDesignUpdatePayload>;
  boothDividerContentElementCreate?: Maybe<GraphQLBoothDividerContentElementCreatePayload>;
  boothDividerContentElementUpdate?: Maybe<GraphQLBoothDividerContentElementUpdatePayload>;
  boothDividerMasterElementCreate?: Maybe<GraphQLBoothDividerMasterElementCreatePayload>;
  boothDividerMasterElementUpdate?: Maybe<GraphQLBoothDividerMasterElementUpdatePayload>;
  boothFileContentElementCreate?: Maybe<GraphQLBoothFileContentElementCreatePayload>;
  boothFileContentElementUpdate?: Maybe<GraphQLBoothFileContentElementUpdatePayload>;
  boothFileMasterElementCreate?: Maybe<GraphQLBoothFileMasterElementCreatePayload>;
  boothFileMasterElementUpdate?: Maybe<GraphQLBoothFileMasterElementUpdatePayload>;
  boothImageContentElementCreate?: Maybe<GraphQLBoothImageContentElementCreatePayload>;
  boothImageContentElementUpdate?: Maybe<GraphQLBoothImageContentElementUpdatePayload>;
  boothImageMasterElementCreate?: Maybe<GraphQLBoothImageMasterElementCreatePayload>;
  boothImageMasterElementUpdate?: Maybe<GraphQLBoothImageMasterElementUpdatePayload>;
  boothMasterElementDelete?: Maybe<GraphQLBoothMasterElementDeletePayload>;
  boothQuestionContentElementCreate?: Maybe<GraphQLBoothQuestionContentElementCreatePayload>;
  boothQuestionContentElementUpdate?: Maybe<GraphQLBoothQuestionContentElementUpdatePayload>;
  boothQuestionMasterElementCreate?: Maybe<GraphQLBoothQuestionMasterElementCreatePayload>;
  boothQuestionMasterElementUpdate?: Maybe<GraphQLBoothQuestionMasterElementUpdatePayload>;
  /** @deprecated call boothUpdate with orderingPosition instead */
  boothReorder?: Maybe<GraphQLBoothReorderPayload>;
  boothRepresentativeCreate?: Maybe<GraphQLBoothRepresentativeCreatePayload>;
  boothRepresentativeDelete?: Maybe<GraphQLBoothRepresentativeDeletePayload>;
  boothRepresentativeUpdate?: Maybe<GraphQLBoothRepresentativeUpdatePayload>;
  boothRichtextContentElementCreate?: Maybe<GraphQLBoothRichtextContentElementCreatePayload>;
  boothRichtextContentElementUpdate?: Maybe<GraphQLBoothRichtextContentElementUpdatePayload>;
  boothRichtextMasterElementCreate?: Maybe<GraphQLBoothRichtextMasterElementCreatePayload>;
  boothRichtextMasterElementUpdate?: Maybe<GraphQLBoothRichtextMasterElementUpdatePayload>;
  boothSupercategoryCreate?: Maybe<GraphQLBoothSupercategoryCreatePayload>;
  boothSupercategoryUpdate?: Maybe<GraphQLBoothSupercategoryUpdatePayload>;
  boothTabContentElementCreate?: Maybe<GraphQLBoothTabContentElementCreatePayload>;
  boothTabContentElementUpdate?: Maybe<GraphQLBoothTabContentElementUpdatePayload>;
  boothTabMasterElementCreate?: Maybe<GraphQLBoothTabMasterElementCreatePayload>;
  boothTabMasterElementUpdate?: Maybe<GraphQLBoothTabMasterElementUpdatePayload>;
  boothTaxonomyDelete?: Maybe<GraphQLBoothTaxonomyDeletePayload>;
  boothTierCreate?: Maybe<GraphQLBoothTierCreatePayload>;
  boothTierDelete?: Maybe<GraphQLBoothTierDeletePayload>;
  boothTierUpdate?: Maybe<GraphQLBoothTierUpdatePayload>;
  boothUpdate?: Maybe<GraphQLBoothUpdatePayload>;
  boothVideoContentElementCreate?: Maybe<GraphQLBoothVideoContentElementCreatePayload>;
  boothVideoContentElementUpdate?: Maybe<GraphQLBoothVideoContentElementUpdatePayload>;
  boothVideoMasterElementCreate?: Maybe<GraphQLBoothVideoMasterElementCreatePayload>;
  boothVideoMasterElementUpdate?: Maybe<GraphQLBoothVideoMasterElementUpdatePayload>;
  confirmationEmailResend?: Maybe<GraphQLConfirmationEmailResendPayload>;
  eventUpdate?: Maybe<GraphQLEventUpdatePayload>;
  groupChatJoin?: Maybe<GraphQLGroupChatJoinPayload>;
  groupChatJoinAsync?: Maybe<GraphQLGroupChatJoinAsyncPayload>;
  groupVideoCallRoomJoinResponse?: Maybe<GraphQLGroupVideoCallRoomJoinResponsePayload>;
  /** Initiate direct file upload */
  initiateDirectUpload?: Maybe<GraphQLInitiateDirectUploadPayload>;
  pushNotification?: Maybe<GraphQLPushNotificationPayload>;
  registerEventxtraAttendeeAsync?: Maybe<GraphQLRegisterEventxtraAttendeeAsyncPayload>;
  registerRongcloudServiceAsync?: Maybe<GraphQLRegisterRongcloudServiceAsyncPayload>;
  removeContact?: Maybe<GraphQLRemoveContactPayload>;
  sendSmsLoginCode?: Maybe<GraphQLSendSmsLoginCodePayload>;
  uploadFile?: Maybe<GraphQLUploadFilePayload>;
  v2GroupVideoCallRoomCreate?: Maybe<GraphQLV2GroupVideoCallRoomCreatePayload>;
  verifySmsLoginCode?: Maybe<GraphQLVerifySmsLoginCodePayload>;
  videoCallParticipantAccept?: Maybe<GraphQLVideoCallParticipantAcceptPayload>;
  videoCallParticipantJoin?: Maybe<GraphQLVideoCallParticipantJoinPayload>;
  videoCallParticipantQuit?: Maybe<GraphQLVideoCallParticipantQuitPayload>;
  videoCallRoomCreate?: Maybe<GraphQLVideoCallRoomCreatePayload>;
  videoCallTokenCreate?: Maybe<GraphQLVideoCallTokenCreatePayload>;
}


export interface GraphQLMutationAddContactArgs {
  input: GraphQLAddContactInput;
}


export interface GraphQLMutationAdminEventCreateArgs {
  input: GraphQLAdminEventCreateInput;
}


export interface GraphQLMutationAttendeeUpdateArgs {
  input: GraphQLAttendeeUpdateInput;
}


export interface GraphQLMutationBoothCategoryCreateArgs {
  input: GraphQLBoothCategoryCreateInput;
}


export interface GraphQLMutationBoothCategoryUpdateArgs {
  input: GraphQLBoothCategoryUpdateInput;
}


export interface GraphQLMutationBoothContentElementDeleteArgs {
  input: GraphQLBoothContentElementDeleteInput;
}


export interface GraphQLMutationBoothCreateArgs {
  input: GraphQLBoothCreateInput;
}


export interface GraphQLMutationBoothDesignCanvasMasterElementUpdateArgs {
  input: GraphQLBoothDesignCanvasMasterElementUpdateInput;
}


export interface GraphQLMutationBoothDesignColorFillElementUpdateArgs {
  input: GraphQLBoothDesignColorFillElementUpdateInput;
}


export interface GraphQLMutationBoothDesignColorFillMasterElementCreateArgs {
  input: GraphQLBoothDesignColorFillMasterElementCreateInput;
}


export interface GraphQLMutationBoothDesignColorFillMasterElementUpdateArgs {
  input: GraphQLBoothDesignColorFillMasterElementUpdateInput;
}


export interface GraphQLMutationBoothDesignContentAreaElementUpdateArgs {
  input: GraphQLBoothDesignContentAreaElementUpdateInput;
}


export interface GraphQLMutationBoothDesignContentAreaMasterElementCreateArgs {
  input: GraphQLBoothDesignContentAreaMasterElementCreateInput;
}


export interface GraphQLMutationBoothDesignContentAreaMasterElementUpdateArgs {
  input: GraphQLBoothDesignContentAreaMasterElementUpdateInput;
}


export interface GraphQLMutationBoothDesignCreateArgs {
  input: GraphQLBoothDesignCreateInput;
}


export interface GraphQLMutationBoothDesignDeleteArgs {
  input: GraphQLBoothDesignDeleteInput;
}


export interface GraphQLMutationBoothDesignElementUpdateArgs {
  input: GraphQLBoothDesignElementUpdateInput;
}


export interface GraphQLMutationBoothDesignImageButtonElementUpdateArgs {
  input: GraphQLBoothDesignImageButtonElementUpdateInput;
}


export interface GraphQLMutationBoothDesignImageButtonMasterElementCreateArgs {
  input: GraphQLBoothDesignImageButtonMasterElementCreateInput;
}


export interface GraphQLMutationBoothDesignImageButtonMasterElementUpdateArgs {
  input: GraphQLBoothDesignImageButtonMasterElementUpdateInput;
}


export interface GraphQLMutationBoothDesignImageMasterElementCreateArgs {
  input: GraphQLBoothDesignImageMasterElementCreateInput;
}


export interface GraphQLMutationBoothDesignImageMasterElementUpdateArgs {
  input: GraphQLBoothDesignImageMasterElementUpdateInput;
}


export interface GraphQLMutationBoothDesignMasterElementDeleteArgs {
  input: GraphQLBoothDesignMasterElementDeleteInput;
}


export interface GraphQLMutationBoothDesignNetworkingWidgetMasterElementCreateArgs {
  input: GraphQLBoothDesignNetworkingWidgetMasterElementCreateInput;
}


export interface GraphQLMutationBoothDesignNetworkingWidgetMasterElementUpdateArgs {
  input: GraphQLBoothDesignNetworkingWidgetMasterElementUpdateInput;
}


export interface GraphQLMutationBoothDesignUpdateArgs {
  input: GraphQLBoothDesignUpdateInput;
}


export interface GraphQLMutationBoothDividerContentElementCreateArgs {
  input: GraphQLBoothDividerContentElementCreateInput;
}


export interface GraphQLMutationBoothDividerContentElementUpdateArgs {
  input: GraphQLBoothDividerContentElementUpdateInput;
}


export interface GraphQLMutationBoothDividerMasterElementCreateArgs {
  input: GraphQLBoothDividerMasterElementCreateInput;
}


export interface GraphQLMutationBoothDividerMasterElementUpdateArgs {
  input: GraphQLBoothDividerMasterElementUpdateInput;
}


export interface GraphQLMutationBoothFileContentElementCreateArgs {
  input: GraphQLBoothFileContentElementCreateInput;
}


export interface GraphQLMutationBoothFileContentElementUpdateArgs {
  input: GraphQLBoothFileContentElementUpdateInput;
}


export interface GraphQLMutationBoothFileMasterElementCreateArgs {
  input: GraphQLBoothFileMasterElementCreateInput;
}


export interface GraphQLMutationBoothFileMasterElementUpdateArgs {
  input: GraphQLBoothFileMasterElementUpdateInput;
}


export interface GraphQLMutationBoothImageContentElementCreateArgs {
  input: GraphQLBoothImageContentElementCreateInput;
}


export interface GraphQLMutationBoothImageContentElementUpdateArgs {
  input: GraphQLBoothImageContentElementUpdateInput;
}


export interface GraphQLMutationBoothImageMasterElementCreateArgs {
  input: GraphQLBoothImageMasterElementCreateInput;
}


export interface GraphQLMutationBoothImageMasterElementUpdateArgs {
  input: GraphQLBoothImageMasterElementUpdateInput;
}


export interface GraphQLMutationBoothMasterElementDeleteArgs {
  input: GraphQLBoothMasterElementDeleteInput;
}


export interface GraphQLMutationBoothQuestionContentElementCreateArgs {
  input: GraphQLBoothQuestionContentElementCreateInput;
}


export interface GraphQLMutationBoothQuestionContentElementUpdateArgs {
  input: GraphQLBoothQuestionContentElementUpdateInput;
}


export interface GraphQLMutationBoothQuestionMasterElementCreateArgs {
  input: GraphQLBoothQuestionMasterElementCreateInput;
}


export interface GraphQLMutationBoothQuestionMasterElementUpdateArgs {
  input: GraphQLBoothQuestionMasterElementUpdateInput;
}


export interface GraphQLMutationBoothReorderArgs {
  input: GraphQLBoothReorderInput;
}


export interface GraphQLMutationBoothRepresentativeCreateArgs {
  input: GraphQLBoothRepresentativeCreateInput;
}


export interface GraphQLMutationBoothRepresentativeDeleteArgs {
  input: GraphQLBoothRepresentativeDeleteInput;
}


export interface GraphQLMutationBoothRepresentativeUpdateArgs {
  input: GraphQLBoothRepresentativeUpdateInput;
}


export interface GraphQLMutationBoothRichtextContentElementCreateArgs {
  input: GraphQLBoothRichtextContentElementCreateInput;
}


export interface GraphQLMutationBoothRichtextContentElementUpdateArgs {
  input: GraphQLBoothRichtextContentElementUpdateInput;
}


export interface GraphQLMutationBoothRichtextMasterElementCreateArgs {
  input: GraphQLBoothRichtextMasterElementCreateInput;
}


export interface GraphQLMutationBoothRichtextMasterElementUpdateArgs {
  input: GraphQLBoothRichtextMasterElementUpdateInput;
}


export interface GraphQLMutationBoothSupercategoryCreateArgs {
  input: GraphQLBoothSupercategoryCreateInput;
}


export interface GraphQLMutationBoothSupercategoryUpdateArgs {
  input: GraphQLBoothSupercategoryUpdateInput;
}


export interface GraphQLMutationBoothTabContentElementCreateArgs {
  input: GraphQLBoothTabContentElementCreateInput;
}


export interface GraphQLMutationBoothTabContentElementUpdateArgs {
  input: GraphQLBoothTabContentElementUpdateInput;
}


export interface GraphQLMutationBoothTabMasterElementCreateArgs {
  input: GraphQLBoothTabMasterElementCreateInput;
}


export interface GraphQLMutationBoothTabMasterElementUpdateArgs {
  input: GraphQLBoothTabMasterElementUpdateInput;
}


export interface GraphQLMutationBoothTaxonomyDeleteArgs {
  input: GraphQLBoothTaxonomyDeleteInput;
}


export interface GraphQLMutationBoothTierCreateArgs {
  input: GraphQLBoothTierCreateInput;
}


export interface GraphQLMutationBoothTierDeleteArgs {
  input: GraphQLBoothTierDeleteInput;
}


export interface GraphQLMutationBoothTierUpdateArgs {
  input: GraphQLBoothTierUpdateInput;
}


export interface GraphQLMutationBoothUpdateArgs {
  input: GraphQLBoothUpdateInput;
}


export interface GraphQLMutationBoothVideoContentElementCreateArgs {
  input: GraphQLBoothVideoContentElementCreateInput;
}


export interface GraphQLMutationBoothVideoContentElementUpdateArgs {
  input: GraphQLBoothVideoContentElementUpdateInput;
}


export interface GraphQLMutationBoothVideoMasterElementCreateArgs {
  input: GraphQLBoothVideoMasterElementCreateInput;
}


export interface GraphQLMutationBoothVideoMasterElementUpdateArgs {
  input: GraphQLBoothVideoMasterElementUpdateInput;
}


export interface GraphQLMutationConfirmationEmailResendArgs {
  input: GraphQLConfirmationEmailResendInput;
}


export interface GraphQLMutationEventUpdateArgs {
  input: GraphQLEventUpdateInput;
}


export interface GraphQLMutationGroupChatJoinArgs {
  input: GraphQLGroupChatJoinInput;
}


export interface GraphQLMutationGroupChatJoinAsyncArgs {
  input: GraphQLGroupChatJoinAsyncInput;
}


export interface GraphQLMutationGroupVideoCallRoomJoinResponseArgs {
  input: GraphQLGroupVideoCallRoomJoinResponseInput;
}


export interface GraphQLMutationInitiateDirectUploadArgs {
  input: GraphQLInitiateDirectUploadInput;
}


export interface GraphQLMutationPushNotificationArgs {
  input: GraphQLPushNotificationInput;
}


export interface GraphQLMutationRegisterEventxtraAttendeeAsyncArgs {
  input: GraphQLRegisterEventxtraAttendeeAsyncInput;
}


export interface GraphQLMutationRegisterRongcloudServiceAsyncArgs {
  input: GraphQLRegisterRongcloudServiceAsyncInput;
}


export interface GraphQLMutationRemoveContactArgs {
  input: GraphQLRemoveContactInput;
}


export interface GraphQLMutationSendSmsLoginCodeArgs {
  input: GraphQLSendSmsLoginCodeInput;
}


export interface GraphQLMutationUploadFileArgs {
  input: GraphQLUploadFileInput;
}


export interface GraphQLMutationV2GroupVideoCallRoomCreateArgs {
  input: GraphQLV2GroupVideoCallRoomCreateInput;
}


export interface GraphQLMutationVerifySmsLoginCodeArgs {
  input: GraphQLVerifySmsLoginCodeInput;
}


export interface GraphQLMutationVideoCallParticipantAcceptArgs {
  input: GraphQLVideoCallParticipantAcceptInput;
}


export interface GraphQLMutationVideoCallParticipantJoinArgs {
  input: GraphQLVideoCallParticipantJoinInput;
}


export interface GraphQLMutationVideoCallParticipantQuitArgs {
  input: GraphQLVideoCallParticipantQuitInput;
}


export interface GraphQLMutationVideoCallRoomCreateArgs {
  input: GraphQLVideoCallRoomCreateInput;
}


export interface GraphQLMutationVideoCallTokenCreateArgs {
  input: GraphQLVideoCallTokenCreateInput;
}

/** An object with an ID. */
export interface GraphQLNode {
  /** ID of the object. */
  id: Scalars['ID'];
}

/** Information about pagination in a connection. */
export interface GraphQLPageInfo {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
}

/** Autogenerated input type of PushNotification */
export interface GraphQLPushNotificationInput {
  eventToken?: Maybe<Scalars['String']>;
  eventDomain?: Maybe<Scalars['String']>;
  uniqueToken: Scalars['String'];
  message: Scalars['String'];
  sender: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of PushNotification */
export interface GraphQLPushNotificationPayload {
  __typename?: 'PushNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLQuery {
  __typename?: 'Query';
  attendeeByUniqueToken?: Maybe<GraphQLAttendee>;
  attendeesByEventToken?: Maybe<GraphQLAttendeeConnection>;
  contactsByUuid?: Maybe<GraphQLUserContactGroupConnection>;
  eventByDomain?: Maybe<GraphQLEvent>;
  eventByToken?: Maybe<GraphQLEvent>;
  fetchAttendeeInformation?: Maybe<Array<GraphQLAttendee>>;
  localizableFileableBy?: Maybe<GraphQLLocalizableFileable>;
  /** Fetches an object given its ID. */
  node?: Maybe<GraphQLNode>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<GraphQLNode>>;
  rongcloudGroup?: Maybe<GraphQLRongcloudGroup>;
  videoCallRoomByToken?: Maybe<GraphQLVideoCallRoom>;
}


export interface GraphQLQueryAttendeeByUniqueTokenArgs {
  eventToken: Scalars['String'];
  uniqueToken: Scalars['String'];
}


export interface GraphQLQueryAttendeesByEventTokenArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  eventToken: Scalars['String'];
  keyword?: Maybe<Scalars['String']>;
}


export interface GraphQLQueryContactsByUuidArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
  keyword?: Maybe<Scalars['String']>;
}


export interface GraphQLQueryEventByDomainArgs {
  domain: Scalars['String'];
}


export interface GraphQLQueryEventByTokenArgs {
  eventToken: Scalars['String'];
}


export interface GraphQLQueryFetchAttendeeInformationArgs {
  eventToken: Scalars['String'];
  ids: Array<Scalars['String']>;
}


export interface GraphQLQueryLocalizableFileableByArgs {
  objectId: Scalars['ID'];
  fieldName: Scalars['String'];
}


export interface GraphQLQueryNodeArgs {
  id: Scalars['ID'];
}


export interface GraphQLQueryNodesArgs {
  ids: Array<Scalars['ID']>;
}


export interface GraphQLQueryRongcloudGroupArgs {
  rongcloudId: Scalars['String'];
}


export interface GraphQLQueryVideoCallRoomByTokenArgs {
  token: Scalars['String'];
}

/** Autogenerated input type of RegisterEventxtraAttendeeAsync */
export interface GraphQLRegisterEventxtraAttendeeAsyncInput {
  eventId: Scalars['ID'];
  uniqueToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of RegisterEventxtraAttendeeAsync */
export interface GraphQLRegisterEventxtraAttendeeAsyncPayload {
  __typename?: 'RegisterEventxtraAttendeeAsyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  job?: Maybe<GraphQLRegisterEventxtraAttendeeJob>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLRegisterEventxtraAttendeeJob extends GraphQLNode, GraphQLJob {
  __typename?: 'RegisterEventxtraAttendeeJob';
  /** ID of the object. */
  id: Scalars['ID'];
  result: GraphQLRegisterEventxtraAttendeeResult;
  status: GraphQLJobStatus;
}

export interface GraphQLRegisterEventxtraAttendeeResult extends GraphQLJobResult {
  __typename?: 'RegisterEventxtraAttendeeResult';
  accessToken?: Maybe<Scalars['String']>;
  attendee?: Maybe<GraphQLAttendee>;
  job: GraphQLJob;
}

/** Autogenerated input type of RegisterRongcloudServiceAsync */
export interface GraphQLRegisterRongcloudServiceAsyncInput {
  rongcloudUserId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of RegisterRongcloudServiceAsync */
export interface GraphQLRegisterRongcloudServiceAsyncPayload {
  __typename?: 'RegisterRongcloudServiceAsyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  job?: Maybe<GraphQLRegisterRongcloudServiceJob>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLRegisterRongcloudServiceJob extends GraphQLNode, GraphQLJob {
  __typename?: 'RegisterRongcloudServiceJob';
  /** ID of the object. */
  id: Scalars['ID'];
  result: GraphQLRegisterRongcloudServiceResult;
  status: GraphQLJobStatus;
}

export interface GraphQLRegisterRongcloudServiceResult extends GraphQLJobResult {
  __typename?: 'RegisterRongcloudServiceResult';
  job: GraphQLJob;
  rongcloudToken?: Maybe<Scalars['String']>;
}

/** Autogenerated input type of RemoveContact */
export interface GraphQLRemoveContactInput {
  userUuid: Scalars['String'];
  contactUuid: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of RemoveContact */
export interface GraphQLRemoveContactPayload {
  __typename?: 'RemoveContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
}

/** RongcloudGroup */
export interface GraphQLRongcloudGroup {
  __typename?: 'RongcloudGroup';
  rongcloudUsers: GraphQLAttendeeConnection;
}


/** RongcloudGroup */
export interface GraphQLRongcloudGroupRongcloudUsersArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
}

export interface GraphQLSearchResult extends GraphQLNode {
  __typename?: 'SearchResult';
  id: Scalars['ID'];
  searchable: GraphQLSearchable;
}

/** The connection type for SearchResult. */
export interface GraphQLSearchResultConnection {
  __typename?: 'SearchResultConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLSearchResultEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLSearchResult>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
export interface GraphQLSearchResultEdge {
  __typename?: 'SearchResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLSearchResult>;
}

/** Searchable objects */
export type GraphQLSearchable = GraphQLBooth;

/** Autogenerated input type of SendSmsLoginCode */
export interface GraphQLSendSmsLoginCodeInput {
  eventId: Scalars['ID'];
  /** Target phone number for sending SMS login code */
  phoneNumber: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of SendSmsLoginCode */
export interface GraphQLSendSmsLoginCodePayload {
  __typename?: 'SendSmsLoginCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLSharedAttachment {
  __typename?: 'SharedAttachment';
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  id: Scalars['Int'];
}


/** Standard error information */
export interface GraphQLStandardError {
  __typename?: 'StandardError';
  details: Array<GraphQLStandardErrorDetail>;
  message: Scalars['String'];
  path: Array<Scalars['StandardErrorPathSegment']>;
  type?: Maybe<Scalars['String']>;
}

/** Standard error detail */
export interface GraphQLStandardErrorDetail {
  __typename?: 'StandardErrorDetail';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
}



/** Autogenerated input type of UploadFile */
export interface GraphQLUploadFileInput {
  eventToken?: Maybe<Scalars['String']>;
  eventDomain?: Maybe<Scalars['String']>;
  /** Upload file */
  file: Scalars['Upload'];
  uniqueToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of UploadFile */
export interface GraphQLUploadFilePayload {
  __typename?: 'UploadFilePayload';
  attachment?: Maybe<GraphQLSharedAttachment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLUserContactGroup {
  __typename?: 'UserContactGroup';
  contact?: Maybe<GraphQLAttendee>;
  createdAt: Scalars['String'];
}

/** The connection type for UserContactGroup. */
export interface GraphQLUserContactGroupConnection {
  __typename?: 'UserContactGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphQLUserContactGroupEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GraphQLUserContactGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: GraphQLPageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
export interface GraphQLUserContactGroupEdge {
  __typename?: 'UserContactGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphQLUserContactGroup>;
}

/** Autogenerated input type of V2GroupVideoCallRoomCreate */
export interface GraphQLV2GroupVideoCallRoomCreateInput {
  boothId: Scalars['ID'];
  participantId: Scalars['ID'];
  imService?: Maybe<GraphQLImService>;
  conversationId?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of V2GroupVideoCallRoomCreate */
export interface GraphQLV2GroupVideoCallRoomCreatePayload {
  __typename?: 'V2GroupVideoCallRoomCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  roomAdmins?: Maybe<GraphQLAttendeeConnection>;
  roomMember?: Maybe<GraphQLVideoCallRoomMember>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
  /** The `VideoCallRoom` object after create */
  videoCallRoom?: Maybe<GraphQLVideoCallRoom>;
}


/** Autogenerated return type of V2GroupVideoCallRoomCreate */
export interface GraphQLV2GroupVideoCallRoomCreatePayloadRoomAdminsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of VerifySmsLoginCode */
export interface GraphQLVerifySmsLoginCodeInput {
  eventId: Scalars['ID'];
  /** Phone number for SMS login code */
  phoneNumber: Scalars['String'];
  /** SMS login code to verify */
  code: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of VerifySmsLoginCode */
export interface GraphQLVerifySmsLoginCodePayload {
  __typename?: 'VerifySmsLoginCodePayload';
  /** attendee unique token after verification is successful */
  attendeeUniqueToken?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLVideo extends GraphQLFileable {
  __typename?: 'Video';
  /** Cloudflare HLS url */
  cfHlsUrl?: Maybe<Scalars['String']>;
  /** Cloudflare state */
  cfState?: Maybe<GraphQLVideoState>;
  /** Cloudflare video ID */
  cfVideoId?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  fileUrl: Scalars['String'];
  filename: Scalars['String'];
  playbackUrl: Scalars['String'];
}

/** Autogenerated input type of VideoCallParticipantAccept */
export interface GraphQLVideoCallParticipantAcceptInput {
  participantId: Scalars['String'];
  roomToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of VideoCallParticipantAccept */
export interface GraphQLVideoCallParticipantAcceptPayload {
  __typename?: 'VideoCallParticipantAcceptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of VideoCallParticipantJoin */
export interface GraphQLVideoCallParticipantJoinInput {
  participantId: Scalars['String'];
  roomToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of VideoCallParticipantJoin */
export interface GraphQLVideoCallParticipantJoinPayload {
  __typename?: 'VideoCallParticipantJoinPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

/** Autogenerated input type of VideoCallParticipantQuit */
export interface GraphQLVideoCallParticipantQuitInput {
  participantId: Scalars['String'];
  roomToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of VideoCallParticipantQuit */
export interface GraphQLVideoCallParticipantQuitPayload {
  __typename?: 'VideoCallParticipantQuitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
}

export interface GraphQLVideoCallRoom extends GraphQLNode {
  __typename?: 'VideoCallRoom';
  id: Scalars['ID'];
  imService?: Maybe<GraphQLImService>;
  kind?: Maybe<GraphQLVideoCallRoomKind>;
  participants: GraphQLAttendeeConnection;
  status?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
}


export interface GraphQLVideoCallRoomParticipantsArgs {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}

/** Autogenerated input type of VideoCallRoomCreate */
export interface GraphQLVideoCallRoomCreateInput {
  inviterId: Scalars['String'];
  inviteeId: Scalars['String'];
  conversationId?: Maybe<Scalars['String']>;
  imService?: Maybe<GraphQLImService>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of VideoCallRoomCreate */
export interface GraphQLVideoCallRoomCreatePayload {
  __typename?: 'VideoCallRoomCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
  /** The `VideoCallRoom` object after create */
  videoCallRoom: GraphQLVideoCallRoom;
}

/** Possible value types for `kind` of a `VideoCallRoom` */
export enum GraphQLVideoCallRoomKind {
  /** private */
  Private = 'PRIVATE',
  /** group */
  Group = 'GROUP'
}

/** VideoCallRoomMember */
export interface GraphQLVideoCallRoomMember extends GraphQLNode {
  __typename?: 'VideoCallRoomMember';
  id: Scalars['ID'];
  isInviter: Scalars['Boolean'];
  status?: Maybe<Scalars['String']>;
  twilioToken?: Maybe<Scalars['String']>;
}

/** Autogenerated input type of VideoCallTokenCreate */
export interface GraphQLVideoCallTokenCreateInput {
  participantId: Scalars['String'];
  roomToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of VideoCallTokenCreate */
export interface GraphQLVideoCallTokenCreatePayload {
  __typename?: 'VideoCallTokenCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors occured during the operation */
  errors: Array<GraphQLStandardError>;
  participant: GraphQLAttendee;
  roomMember?: Maybe<GraphQLVideoCallRoomMember>;
  /** Whether the operation is successful */
  success: Scalars['Boolean'];
  videoCallRoom?: Maybe<GraphQLVideoCallRoom>;
}

/** Possible value types for `state` of a `Video` */
export enum GraphQLVideoState {
  /** Downloading */
  Downloading = 'DOWNLOADING',
  /** Inprogress */
  Inprogress = 'INPROGRESS',
  /** Ready */
  Ready = 'READY',
  /** Error */
  Error = 'ERROR'
}

export type GraphQLColorFillElementFragment = (
  { __typename?: 'BoothDesignColorFillElement' }
  & Pick<GraphQLBoothDesignColorFillElement, 'fillColor'>
  & { name: GraphQLBoothDesignColorFillElement['keyName'] }
  & { maskImage: (
    { __typename?: 'LocalizableImage' }
    & GraphQLCommonLocalizableImageFragment
  ) }
);

export type GraphQLCommonLocalizableFileFragment = (
  { __typename?: 'LocalizableFile' }
  & { values?: Maybe<Array<(
    { __typename?: 'LocalizableFileValue' }
    & Pick<GraphQLLocalizableFileValue, 'locale'>
    & { value?: Maybe<(
      { __typename?: 'File' }
      & Pick<GraphQLFile, 'fileUrl' | 'filename'>
    )> }
  )>> }
);

export type GraphQLCommonLocalizableImageFragment = (
  { __typename?: 'LocalizableImage' }
  & { values?: Maybe<Array<(
    { __typename?: 'LocalizableImageValue' }
    & Pick<GraphQLLocalizableImageValue, 'locale'>
    & { value?: Maybe<(
      { __typename?: 'Image' }
      & Pick<GraphQLImage, 'originalImageUrl'>
    )> }
  )>> }
);

export type GraphQLCommonLocalizableStringFragment = (
  { __typename?: 'LocalizableString' }
  & { values?: Maybe<Array<(
    { __typename?: 'LocalizableStringValue' }
    & Pick<GraphQLLocalizableStringValue, 'locale' | 'value'>
  )>> }
);

export type GraphQLCommonLocalizableVideoFragment = (
  { __typename?: 'LocalizableVideo' }
  & { values?: Maybe<Array<(
    { __typename?: 'LocalizableVideoValue' }
    & Pick<GraphQLLocalizableVideoValue, 'locale'>
    & { value?: Maybe<(
      { __typename?: 'Video' }
      & Pick<GraphQLVideo, 'playbackUrl' | 'cfHlsUrl' | 'cfState' | 'cfVideoId'>
    )> }
  )>> }
);

type GraphQLCommonV2DesignElement_BoothDesignCanvasElement_Fragment = (
  { __typename?: 'BoothDesignCanvasElement' }
  & Pick<GraphQLBoothDesignCanvasElement, 'id'>
  & { positionX?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, positionY?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, width?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, height?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )> }
);

type GraphQLCommonV2DesignElement_BoothDesignColorFillElement_Fragment = (
  { __typename?: 'BoothDesignColorFillElement' }
  & Pick<GraphQLBoothDesignColorFillElement, 'id'>
  & { positionX?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, positionY?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, width?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, height?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )> }
);

type GraphQLCommonV2DesignElement_BoothDesignContentAreaElement_Fragment = (
  { __typename?: 'BoothDesignContentAreaElement' }
  & Pick<GraphQLBoothDesignContentAreaElement, 'id'>
  & { positionX?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, positionY?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, width?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, height?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )> }
);

type GraphQLCommonV2DesignElement_BoothDesignImageButtonElement_Fragment = (
  { __typename?: 'BoothDesignImageButtonElement' }
  & Pick<GraphQLBoothDesignImageButtonElement, 'id'>
  & { positionX?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, positionY?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, width?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, height?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )> }
);

type GraphQLCommonV2DesignElement_BoothDesignImageElement_Fragment = (
  { __typename?: 'BoothDesignImageElement' }
  & Pick<GraphQLBoothDesignImageElement, 'id'>
  & { positionX?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, positionY?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, width?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, height?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )> }
);

type GraphQLCommonV2DesignElement_BoothDesignNetworkingWidgetElement_Fragment = (
  { __typename?: 'BoothDesignNetworkingWidgetElement' }
  & Pick<GraphQLBoothDesignNetworkingWidgetElement, 'id'>
  & { positionX?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, positionY?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, width?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )>, height?: Maybe<(
    { __typename?: 'DisplayMeasurement' }
    & GraphQLMeasurementFragment
  )> }
);

export type GraphQLCommonV2DesignElementFragment = GraphQLCommonV2DesignElement_BoothDesignCanvasElement_Fragment | GraphQLCommonV2DesignElement_BoothDesignColorFillElement_Fragment | GraphQLCommonV2DesignElement_BoothDesignContentAreaElement_Fragment | GraphQLCommonV2DesignElement_BoothDesignImageButtonElement_Fragment | GraphQLCommonV2DesignElement_BoothDesignImageElement_Fragment | GraphQLCommonV2DesignElement_BoothDesignNetworkingWidgetElement_Fragment;

export type GraphQLContentAreaElementFragment = (
  { __typename?: 'BoothDesignContentAreaElement' }
  & { kind: GraphQLBoothDesignContentAreaElement['contentType'], name: GraphQLBoothDesignContentAreaElement['keyName'] }
  & { contentRichtextHtml: (
    { __typename?: 'LocalizableString' }
    & GraphQLCommonLocalizableStringFragment
  ), image: (
    { __typename?: 'LocalizableImage' }
    & GraphQLCommonLocalizableImageFragment
  ), video: (
    { __typename?: 'LocalizableVideo' }
    & GraphQLCommonLocalizableVideoFragment
  ), pdf: (
    { __typename?: 'LocalizableFile' }
    & GraphQLCommonLocalizableFileFragment
  ), thumbnailImage: (
    { __typename?: 'LocalizableImage' }
    & GraphQLCommonLocalizableImageFragment
  ) }
);

export type GraphQLImageButtonElementFragment = (
  { __typename?: 'BoothDesignImageButtonElement' }
  & Pick<GraphQLBoothDesignImageButtonElement, 'actionType' | 'actionExternalLinkUrl'>
  & { name: GraphQLBoothDesignImageButtonElement['keyName'] }
  & { normalStateImage: (
    { __typename?: 'LocalizableImage' }
    & GraphQLCommonLocalizableImageFragment
  ), hoverStateImage: (
    { __typename?: 'LocalizableImage' }
    & GraphQLCommonLocalizableImageFragment
  ) }
);

export type GraphQLImageElementFragment = (
  { __typename?: 'BoothDesignImageElement' }
  & { image: (
    { __typename?: 'LocalizableImage' }
    & GraphQLCommonLocalizableImageFragment
  ) }
);

export type GraphQLMeasurementFragment = (
  { __typename?: 'DisplayMeasurement' }
  & Pick<GraphQLDisplayMeasurement, 'dimension' | 'unit'>
);

export type GraphQLFetchCanPerformOnBoothQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GraphQLFetchCanPerformOnBoothQuery = (
  { __typename?: 'Query' }
  & { data?: Maybe<(
    { __typename?: 'Booth' }
    & { canPerformVisitUnrestricted: GraphQLBooth['currentAbilityCanPerform'], canPerformVisitRestricted: GraphQLBooth['currentAbilityCanPerform'] }
  ) | { __typename?: 'BoothCategory' } | { __typename?: 'BoothDesign' } | { __typename?: 'BoothDesignCanvasElement' } | { __typename?: 'BoothDesignColorFillElement' } | { __typename?: 'BoothDesignContentAreaElement' } | { __typename?: 'BoothDesignElement' } | { __typename?: 'BoothDesignImageButtonElement' } | { __typename?: 'BoothDesignImageElement' } | { __typename?: 'BoothDesignNetworkingWidgetElement' } | { __typename?: 'BoothDividerContentElement' } | { __typename?: 'BoothDividerMasterElement' } | { __typename?: 'BoothFileContentElement' } | { __typename?: 'BoothFileMasterElement' } | { __typename?: 'BoothImageContentElement' } | { __typename?: 'BoothImageMasterElement' } | { __typename?: 'BoothQuestionContentElement' } | { __typename?: 'BoothQuestionMasterElement' } | { __typename?: 'BoothRichtextContentElement' } | { __typename?: 'BoothRichtextMasterElement' } | { __typename?: 'BoothRootContentElement' } | { __typename?: 'BoothRootMasterElement' } | { __typename?: 'BoothSupercategory' } | { __typename?: 'BoothTabContentElement' } | { __typename?: 'BoothTabMasterElement' } | { __typename?: 'BoothTier' } | { __typename?: 'BoothVideoContentElement' } | { __typename?: 'BoothVideoMasterElement' } | { __typename?: 'Event' } | { __typename?: 'GroupChatJoinJob' } | { __typename?: 'Hall' } | { __typename?: 'RegisterEventxtraAttendeeJob' } | { __typename?: 'RegisterRongcloudServiceJob' } | { __typename?: 'SearchResult' } | { __typename?: 'VideoCallRoom' } | { __typename?: 'VideoCallRoomMember' }> }
);

export type GraphQLFetchCanPerformOnEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GraphQLFetchCanPerformOnEventQuery = (
  { __typename?: 'Query' }
  & { data?: Maybe<{ __typename?: 'Booth' } | { __typename?: 'BoothCategory' } | { __typename?: 'BoothDesign' } | { __typename?: 'BoothDesignCanvasElement' } | { __typename?: 'BoothDesignColorFillElement' } | { __typename?: 'BoothDesignContentAreaElement' } | { __typename?: 'BoothDesignElement' } | { __typename?: 'BoothDesignImageButtonElement' } | { __typename?: 'BoothDesignImageElement' } | { __typename?: 'BoothDesignNetworkingWidgetElement' } | { __typename?: 'BoothDividerContentElement' } | { __typename?: 'BoothDividerMasterElement' } | { __typename?: 'BoothFileContentElement' } | { __typename?: 'BoothFileMasterElement' } | { __typename?: 'BoothImageContentElement' } | { __typename?: 'BoothImageMasterElement' } | { __typename?: 'BoothQuestionContentElement' } | { __typename?: 'BoothQuestionMasterElement' } | { __typename?: 'BoothRichtextContentElement' } | { __typename?: 'BoothRichtextMasterElement' } | { __typename?: 'BoothRootContentElement' } | { __typename?: 'BoothRootMasterElement' } | { __typename?: 'BoothSupercategory' } | { __typename?: 'BoothTabContentElement' } | { __typename?: 'BoothTabMasterElement' } | { __typename?: 'BoothTier' } | { __typename?: 'BoothVideoContentElement' } | { __typename?: 'BoothVideoMasterElement' } | (
    { __typename?: 'Event' }
    & { canPerformVisitUnrestricted: GraphQLEvent['currentAbilityCanPerform'], canPerformVisitRestricted: GraphQLEvent['currentAbilityCanPerform'] }
  ) | { __typename?: 'GroupChatJoinJob' } | { __typename?: 'Hall' } | { __typename?: 'RegisterEventxtraAttendeeJob' } | { __typename?: 'RegisterRongcloudServiceJob' } | { __typename?: 'SearchResult' } | { __typename?: 'VideoCallRoom' } | { __typename?: 'VideoCallRoomMember' }> }
);

export type GraphQLFetchXtraEventQueryVariables = Exact<{
  domain: Scalars['String'];
}>;


export type GraphQLFetchXtraEventQuery = (
  { __typename?: 'Query' }
  & { data?: Maybe<(
    { __typename?: 'Event' }
    & Pick<GraphQLEvent, 'id' | 'locales' | 'defaultLocale' | 'features' | 'createdAt'>
  )> }
);

export const CommonLocalizableImageFragmentDoc = gql`
    fragment CommonLocalizableImage on LocalizableImage {
  values(locales: $locales) {
    locale
    value {
      originalImageUrl
    }
  }
}
    `;
export const ColorFillElementFragmentDoc = gql`
    fragment ColorFillElement on BoothDesignColorFillElement {
  maskImage {
    ...CommonLocalizableImage
  }
  fillColor
  name: keyName
}
    ${CommonLocalizableImageFragmentDoc}`;
export const MeasurementFragmentDoc = gql`
    fragment Measurement on DisplayMeasurement {
  dimension
  unit
}
    `;
export const CommonV2DesignElementFragmentDoc = gql`
    fragment CommonV2DesignElement on BoothV2DesignElement {
  id
  positionX {
    ...Measurement
  }
  positionY {
    ...Measurement
  }
  width {
    ...Measurement
  }
  height {
    ...Measurement
  }
}
    ${MeasurementFragmentDoc}`;
export const CommonLocalizableStringFragmentDoc = gql`
    fragment CommonLocalizableString on LocalizableString {
  values(locales: $locales) {
    locale
    value
  }
}
    `;
export const CommonLocalizableVideoFragmentDoc = gql`
    fragment CommonLocalizableVideo on LocalizableVideo {
  values(locales: $locales) {
    locale
    value {
      playbackUrl
      cfHlsUrl
      cfState
      cfVideoId
    }
  }
}
    `;
export const CommonLocalizableFileFragmentDoc = gql`
    fragment CommonLocalizableFile on LocalizableFile {
  values(locales: $locales) {
    locale
    value {
      fileUrl
      filename
    }
  }
}
    `;
export const ContentAreaElementFragmentDoc = gql`
    fragment ContentAreaElement on BoothDesignContentAreaElement {
  contentRichtextHtml {
    ...CommonLocalizableString
  }
  image: contentImage {
    ...CommonLocalizableImage
  }
  video: contentVideo {
    ...CommonLocalizableVideo
  }
  pdf: contentPdf {
    ...CommonLocalizableFile
  }
  thumbnailImage {
    ...CommonLocalizableImage
  }
  kind: contentType
  name: keyName
}
    ${CommonLocalizableStringFragmentDoc}
${CommonLocalizableImageFragmentDoc}
${CommonLocalizableVideoFragmentDoc}
${CommonLocalizableFileFragmentDoc}`;
export const ImageButtonElementFragmentDoc = gql`
    fragment ImageButtonElement on BoothDesignImageButtonElement {
  normalStateImage {
    ...CommonLocalizableImage
  }
  hoverStateImage {
    ...CommonLocalizableImage
  }
  actionType
  actionExternalLinkUrl
  name: keyName
}
    ${CommonLocalizableImageFragmentDoc}`;
export const ImageElementFragmentDoc = gql`
    fragment ImageElement on BoothDesignImageElement {
  image {
    ...CommonLocalizableImage
  }
}
    ${CommonLocalizableImageFragmentDoc}`;
export const FetchCanPerformOnBoothDocument = gql`
    query fetchCanPerformOnBooth($id: ID!) {
  data: node(id: $id) {
    ... on Booth {
      canPerformVisitUnrestricted: currentAbilityCanPerform(action: "visit_unrestricted")
      canPerformVisitRestricted: currentAbilityCanPerform(action: "visit_restricted")
    }
  }
}
    `;
export const FetchCanPerformOnEventDocument = gql`
    query fetchCanPerformOnEvent($id: ID!) {
  data: node(id: $id) {
    ... on Event {
      canPerformVisitUnrestricted: currentAbilityCanPerform(action: "visit_unrestricted")
      canPerformVisitRestricted: currentAbilityCanPerform(action: "visit_restricted")
    }
  }
}
    `;
export const FetchXtraEventDocument = gql`
    query fetchXtraEvent($domain: String!) {
  data: eventByDomain(domain: $domain) {
    id
    locales
    defaultLocale
    features
    createdAt
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: () => Promise<T>) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = sdkFunction => sdkFunction();
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    fetchCanPerformOnBooth(variables: GraphQLFetchCanPerformOnBoothQueryVariables): Promise<GraphQLFetchCanPerformOnBoothQuery> {
      return withWrapper(() => client.request<GraphQLFetchCanPerformOnBoothQuery>(print(FetchCanPerformOnBoothDocument), variables));
    },
    fetchCanPerformOnEvent(variables: GraphQLFetchCanPerformOnEventQueryVariables): Promise<GraphQLFetchCanPerformOnEventQuery> {
      return withWrapper(() => client.request<GraphQLFetchCanPerformOnEventQuery>(print(FetchCanPerformOnEventDocument), variables));
    },
    fetchXtraEvent(variables: GraphQLFetchXtraEventQueryVariables): Promise<GraphQLFetchXtraEventQuery> {
      return withWrapper(() => client.request<GraphQLFetchXtraEventQuery>(print(FetchXtraEventDocument), variables));
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;